<template>
  <div class="rkld">
    <div class="rkldRight">
      <div class="rkldRightContent">
        <!-- tabs导航 -->
        <el-tabs v-model="editableTabsValue" type="card">
          <el-tab-pane label="管理" name="1">
            <!--搜索框-->
            <div class="searchTj">
              <div class="searchTjHead">
                <span>查询条件</span>
                <i
                  class="searchDomw"
                  @click="searchValue = !searchValue"
                  :class="
                    searchValue == true
                      ? 'el-icon-arrow-up'
                      : 'el-icon-arrow-down'
                  "
                ></i>
              </div>
              <el-form
                :model="form"
                class="searchTjContent"
                v-show="searchValue"
              >
                <div class="searchTjContentDiv">
                  <span class="searchTjContentDivSpan" style="margin-right: 0"
                    >姓名</span
                  >
                  <el-input
                    v-model="form.customerName"
                    placeholder="请输入"
                    class="searchTjContentDivInput"
                  ></el-input>
                </div>
                <div class="searchTjContentDiv" v-show="searchValue">
                  <span class="searchTjContentDivSpan">生活区域</span>
                  <el-select
                    v-model="form.lifeArea"
                    placeholder="请选择"
                    style="width: 100%"
                  >
                    <el-option label="农村" value="2"></el-option>
                    <el-option label="城市" value="1"></el-option>
                  </el-select>
                </div>
                <div class="searchTjContentDiv" v-show="searchValue">
                  <span class="searchTjContentDivSpan">用户类型</span>
                  <el-select
                    v-model="form.minzhengIndex"
                    placeholder="请选择"
                    style="width: 100%"
                  >
                    <el-option
                      v-for="(item, index) in usertypeList"
                      :key="index"
                      :label="item.dictLabel"
                      :value="item.dictCode"
                    ></el-option>
                  </el-select>
                </div>
                <div class="searchTjContentDiv" v-show="searchValue">
                  <el-button type="primary" class="searchBtns" @click="query"
                    >查询
                  </el-button>
                </div>
                <div class="searchTjContentDiv" v-show="searchValue">
                  <el-button type="info" class="resetReach" @click="resert"
                    >重置
                  </el-button>
                </div>
              </el-form>
            </div>
            <div class="searchButtonDiv" v-show="quanbu">
              <div class="searchButtonDivLeft">
                <el-button-group>
                  <el-button
                    icon="el-icon-plus"
                    class="openBtns"
                    type="success"
                    @click="handleClick('新增', 0)"
                    >新增
                  </el-button>
                  <el-button
                    type="primary"
                    icon="el-icon-download"
                    class="button downOutBtns"
                    @click="Export"
                    >导出全部Excel
                  </el-button>
                  <el-button
                    icon="el-icon-close"
                    type="danger"
                    @click="batchDelete"
                    >批量删除</el-button
                  >
                  <el-button icon="el-icon-edit" type="info" @click="batchClear"
                    >清除号码</el-button
                  >
                </el-button-group>
              </div>
              <!-- 筛选按钮 -->
              <div class="searchButtonDiveRight">
                <el-button-group>
                  <el-button
                    type="primary"
                    class="dropRests"
                    icon="el-icon-refresh"
                    @click="resertTable"
                  ></el-button>
                  <!-- <el-button type="primary"> -->
                  <el-dropdown
                    class="dropdown"
                    trigger="click"
                    :hide-on-click="false"
                  >
                    <span class="el-dropdown-link">
                      <i
                        class="el-icon-s-grid el-icon--right"
                        style="color: #fff"
                      ></i>
                      <i class="el-icon-arrow-down el-icon--right"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item>
                        <template>
                          <el-checkbox-group
                            v-model="checkList"
                            :min="1"
                            @change="tableShow"
                          >
                            <el-checkbox label="序号">序号 </el-checkbox>
                            <br />
                            <el-checkbox label="姓名">姓名 </el-checkbox>
                            <br />
                            <el-checkbox label="年龄">年龄 </el-checkbox>
                            <br />
                            <el-checkbox label="性别">性别 </el-checkbox>
                            <br />
                            <el-checkbox label="手机号码"
                              >手机号码
                            </el-checkbox>
                            <br />
                            <el-checkbox label="老人类别"
                              >老人类别
                            </el-checkbox>
                            <br />
                            <el-checkbox label="用户类型"
                              >用户类型
                            </el-checkbox>
                            <br />
                            <el-checkbox label="居住地址"
                              >居住地址
                            </el-checkbox>
                            <br />
                            <el-checkbox label="信息回访进度"
                              >信息回访进度
                            </el-checkbox>
                            <br />
                            <el-checkbox label="走访探望进度"
                              >走访探望进度
                            </el-checkbox>
                            <br />
                            <el-checkbox label="操作">操作 </el-checkbox>
                            <br />
                          </el-checkbox-group>
                        </template>
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                  <!-- </el-button> -->
                </el-button-group>
              </div>
            </div>
            <!--表单-->
            <div class="addForm">
              <el-table
                ref="multipleTable"
                :data="tableDate"
                tooltip-effect="dark"
                @selection-change="handleSelectionChange"
                :header-cell-style="{
                  background: '#e6e6e6',
                  color: '#000',
                }"
                style="width: 100%"
                border
              >
                <el-table-column type="selection" width="50" align="center">
                </el-table-column>
                <el-table-column
                  type="index"
                  width="70"
                  label="序号"
                  align="center"
                  v-if="no1"
                  show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                  prop="customerName"
                  label="姓名"
                  min-width="100"
                  align="center"
                  v-if="no2"
                  show-overflow-tooltip
                >
                </el-table-column>
                <el-table-column
                  prop="age"
                  label="年龄"
                  align="center"
                  show-overflow-tooltip
                  v-if="no3"
                >
                </el-table-column>
                <el-table-column
                  prop="gender"
                  label="性别"
                  align="center"
                  show-overflow-tooltip
                  v-if="no4"
                >
                  <template slot-scope="scope">
                    <span v-if="scope.row.gender == 0">男</span>
                    <span v-if="scope.row.gender == 1">女</span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="phone"
                  label="手机号码"
                  align="center"
                  min-width="180"
                  show-overflow-tooltip
                  v-if="no5"
                >
                </el-table-column>
                <el-table-column
                  prop="elderlyBelongCategory"
                  label="老人类别"
                  align="center"
                  show-overflow-tooltip
                  v-if="no6"
                >
                  <template slot-scope="scope">
                    <span v-for="(item, index) in oldtypeLits" :key="index"
                      ><span
                        v-if="scope.row.elderlyBelongCategory == item.dictCode"
                        >{{ item.dictLabel }}</span
                      ></span
                    >
                  </template>
                </el-table-column>
                <el-table-column
                  prop="minzhengIndex"
                  label="用户类型"
                  align="center"
                  min-width="200"
                  show-overflow-tooltip
                  v-if="no7"
                >
                  <template slot-scope="scope">
                    <span v-for="(item, index) in usertypeList" :key="index"
                      ><span v-if="scope.row.minzhengIndex == item.dictCode">{{
                        item.dictLabel
                      }}</span></span
                    >
                  </template>
                </el-table-column>
                <el-table-column
                  prop="address"
                  label="居住地址"
                  min-width="200"
                  align="center"
                  show-overflow-tooltip
                  v-if="no8"
                >
                </el-table-column>
                <el-table-column
                  label="信息回访进度"
                  min-width="200"
                  align="center"
                  show-overflow-tooltip
                  v-if="no9"
                >
                  <template slot-scope="scope">
                    <span @click="look('信息回访', scope.row, false)">
                      {{ scope.row.overtotal ? scope.row.overtotal : 0 }}/{{
                        scope.row.total ? scope.row.total : 0
                      }}
                    </span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="走访探望进度"
                  min-width="200"
                  align="center"
                  show-overflow-tooltip
                  v-if="no10"
                >
                  <template slot-scope="scope">
                    <span @click="look('走访探望', scope.row)">{{
                      scope.row.overtotalts + "/" + scope.row.totalts
                    }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="操作"
                  align="center"
                  fixed="right"
                  min-width="400"
                  v-if="no12"
                >
                  <template slot-scope="scope">
                    <el-link
                      :underline="false"
                      class="span_icon"
                      @click="handleClick('查看', 1, scope.row)"
                      >查看
                    </el-link>
                    <el-link
                      :underline="false"
                      class="span_icon"
                      @click="handleClick('编辑', 1, scope.row)"
                      >编辑
                    </el-link>
                    <el-link
                      :underline="false"
                      class="span_icon"
                      @click="look('信息回访', scope.row, true)"
                      >信息回访
                    </el-link>
                    <el-link
                      :underline="false"
                      class="span_icon"
                      @click="look('走访探望', scope.row)"
                      >探望记录
                    </el-link>
                    <el-link
                      :underline="false"
                      class="span_icon"
                      @click="handleClick('反馈问题', 4, scope.row)"
                      >反馈问题
                    </el-link>
                    <el-link
                      :underline="false"
                      class="span_icon"
                      @click="showdelete(scope.row.id)"
                    >
                      删除
                    </el-link>
                  </template>
                </el-table-column>
              </el-table>
              <!-- 分页 -->
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="10"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
              ></el-pagination>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <!-- 新增功能模态框 -->
    <div class="addFrom">
      <el-dialog
        :title="dialogTitle"
        :visible.sync="dialogVisible"
        width="990px"
        :before-close="handleClose"
        @close="handleAddFormClose"
      >
        <el-steps
          :active="stepIndex"
          align-center
          v-show="stepIndex != 0"
          v-if="visitShow1 == false"
        >
          <el-step><span slot="icon">基本信息</span></el-step>
          <el-step><span slot="icon">探望记录</span></el-step>
        </el-steps>
        <!-- 基本信息 -->
        <div
          class="dialog_content_pane"
          v-show="stepIndex == 0 || stepIndex == 1"
        >
          <el-form
            label-width="100px"
            :model="formData"
            ref="formData"
            :rules="formDateRules"
            :disabled="dialogTitle == '查看'"
          >
            <el-row>
              <el-col :span="24">
                <el-row
                  style="
                    display: flex;
                    align-items: center;
                    margin-bottom: 20px;
                  "
                >
                  <el-col :span="18">
                    <el-row class="dialog_form_left">
                      <el-col :span="11">
                        <el-form-item label="姓名:" prop="oldId">
                          <el-select
                            v-model="formData.oldId"
                            filterable
                            remote
                            style="width: 100%"
                            placeholder="请输入关键词"
                            :disabled="
                              dialogTitle === '查看' || dialogTitle === '编辑'
                            "
                            :remote-method="remoteMethod"
                            @change="handleSelect"
                            @click.native="clearForm"
                            :loading="loading"
                          >
                            <el-option
                              v-for="item in options"
                              :key="item.id"
                              :label="item.customerName"
                              :value="item.id"
                            >
                            </el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col :span="11" :offset="1">
                        <el-form-item label="年龄：" prop="age">
                          <el-input v-model="formData.age" disabled></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="11">
                        <el-form-item label="身份证号：" prop="idCard">
                          <!-- <el-input
                                                        v-model="
                                                            formData.idCard
                                                        "
                                                        @change="idCardchange"
                                                        @blur="checkIdNumber"
                                                    ></el-input> -->
                          <el-select
                            v-model="formData.idCard"
                            filterable
                            remote
                            style="width: 100%"
                            placeholder="请输入关键词"
                            :disabled="
                              dialogTitle === '查看' || dialogTitle === '编辑'
                            "
                            :remote-method="remoteMethod1"
                            @change="handleSelect"
                            @click.native="clearForm1"
                            :loading="loading"
                          >
                            <el-option
                              v-for="item in options"
                              :key="item.id"
                              :label="item.idCard"
                              :value="item.id"
                            >
                            </el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col :span="11" :offset="1">
                        <el-form-item label="性别：" prop="gender">
                          <el-select
                            disabled
                            v-model="formData.gender"
                            placeholder="请选择性别"
                            style="width: 100%"
                          >
                            <el-option label="男" value="0"></el-option>
                            <el-option label="女" value="1"></el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col :span="11">
                        <el-form-item label="出生年月：" prop="birthday">
                          <el-date-picker
                            disabled
                            v-model="formData.birthday"
                            type="date"
                            placeholder="选择日期"
                            value-format="yyyy-MM-dd"
                            style="width: 100%"
                          >
                          </el-date-picker>
                        </el-form-item>
                      </el-col>
                      <el-col :span="11" :offset="1">
                        <el-form-item label="手机号：" prop="phone">
                          <el-input
                            v-model="formData.phone"
                            disabled
                            @blur="checkMobile"
                          ></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="11">
                        <el-form-item label="民族：" prop="nation">
                          <el-select
                            v-model="formData.nation"
                            placeholder="请选择"
                            style="width: 100%"
                            disabled
                          >
                            <el-option
                              v-for="item in nation"
                              :key="item"
                              :label="item"
                              :value="item"
                            >
                            </el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col :span="11" :offset="1">
                        <el-form-item label="座机号：" prop="familyCall">
                          <el-input
                            v-model="formData.familyCall"
                            disabled
                          ></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item prop="photo" class="photoFrom">
                      <div class="upImg">
                        <el-upload
                          :action="actionUrl"
                          :show-file-list="false"
                          :on-success="handleAvatarSuccess"
                          :before-upload="beforeAvatarUpload"
                          disabled
                        >
                          <div class="avatar" v-if="formData.photo">
                            <img :src="formData.photo" />
                          </div>
                          <div v-else style="text-align: center; width: 178px">
                            <i
                              class="el-icon-plus avatar_uploader avatar-uploader-icon"
                            ></i>
                          </div>
                        </el-upload>
                      </div>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item label="生活区域：" prop="lifeArea">
                  <el-select
                    v-model="formData.lifeArea"
                    placeholder="请选择"
                    style="width: 100%"
                    disabled
                  >
                    <el-option label="农村" value="2"></el-option>
                    <el-option label="城市" value="1"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="老人类别：" prop="elderlyBelongCategory">
                  <el-select
                    v-model="formData.elderlyBelongCategory"
                    placeholder="请选择"
                    disabled
                    style="width: 100%"
                  >
                    <el-option
                      v-for="(item, index) in oldtypeLits"
                      :key="index"
                      :label="item.dictLabel"
                      :value="item.dictCode"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="用户类型：" prop="minzhengIndex">
                  <el-select
                    v-model="formData.minzhengIndex"
                    placeholder="请选择用户类型"
                    style="width: 100%"
                  >
                    <el-option
                      v-for="(item, index) in usertypeList"
                      :key="index"
                      :label="item.dictLabel"
                      :value="item.dictCode"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <div class="addressFrom">
              <div class="addressTitle"><span>*</span>居住地址:</div>
              <div class="addressContent">
                <div class="addressBox">
                  <div class="addressItem">
                    <el-form-item prop="provinceId">
                      <el-select
                        disabled
                        v-model="formData.provinceId"
                        placeholder="请选择省"
                        @change="handleProvince"
                        ref="selectShengChange"
                      >
                        <el-option
                          v-for="(item, index) in provinceList"
                          :key="index"
                          :label="item.name"
                          :value="item.adcode"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                  <div class="addressItem">
                    <el-form-item prop="cityId">
                      <el-select
                        disabled
                        v-model="formData.cityId"
                        placeholder="请选择市"
                        @change="handleCity"
                        ref="selectShiChange"
                      >
                        <el-option
                          v-for="(item, index) in cityList"
                          :key="index"
                          :label="item.name"
                          :value="item.adcode"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                  <div class="addressItem">
                    <el-form-item prop="areaId">
                      <el-select
                        disabled
                        v-model="formData.areaId"
                        placeholder="请选择区"
                        @change="handleArea"
                        ref="selectQuChange"
                      >
                        <el-option
                          v-for="(item, index) in areaList"
                          :key="index"
                          :label="item.name"
                          :value="item.adcode"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                  <div class="addressItem">
                    <el-form-item prop="streetId">
                      <el-select
                        disabled
                        v-model="formData.streetId"
                        placeholder="请选择街道"
                        @change="streetChange"
                        ref="selectJiedaoChange"
                      >
                        <el-option
                          v-for="(item, index) in streetList"
                          :key="index"
                          :label="item.addName"
                          :value="item.addCode"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                  <div class="addressItem">
                    <el-form-item prop="communityId">
                      <el-select
                        disabled
                        v-model="formData.communityId"
                        @change="handleCommunityChange"
                        placeholder="请选择社区"
                        ref="selectShequChange"
                      >
                        <el-option
                          v-for="item in communityList"
                          :key="item.id"
                          :label="item.address"
                          :value="item.id"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                </div>
                <el-form-item prop="address">
                  <input
                    v-model.trim="formData.address"
                    disabled
                    id="tipinput"
                    class="el-input__inner"
                    :class="dialogTitle == '查看' ? 'innerCur' : ''"
                    @focus="getMap('tipinput')"
                    placeholder="请输入关键字"
                    autocomplete="off"
                  />
                </el-form-item>
                <div class="map_container">
                  <div id="container" style="width: 100%; height: 300px"></div>
                </div>
              </div>
            </div>
            <el-form-item label="居住情况：" prop="liveCondition">
              <el-radio-group v-model="formData.liveCondition" disabled>
                <el-radio label="1">空巢老人</el-radio>
                <el-radio label="2">留守老人</el-radio>
                <el-radio label="4">独自居住</el-radio>
                <el-radio label="5">与配偶居住</el-radio>
                <el-radio label="3">与子女同住</el-radio>
                <el-radio label="6">其他</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="经济来源：" prop="economicSource">
              <el-checkbox-group v-model="formData.economicSource" disabled>
                <el-checkbox label="0">养老金</el-checkbox>
                <el-checkbox label="1">子女供养</el-checkbox>
                <el-checkbox label="2">救济优抚</el-checkbox>
                <el-checkbox label="3">兼职</el-checkbox>
                <el-checkbox label="4">其他</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item label="所属机构：" prop="serviceStation">
              <!--              <el-input-->
              <!--                v-model='formData.serviceStation'-->
              <!--              ></el-input>-->
              <el-select
                placeholder="请选择所属机构"
                v-model.number="formData.serviceStation"
                disabled
              >
                <el-option
                  v-for="item in optionsType"
                  :key="item.id"
                  :label="item.statName"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>

        <!-- 探望记录 -->
        <div class="dialog_content_pane" v-show="stepIndex == 3">
          <el-table
            :data="tableDate2"
            tooltip-effect="dark"
            @row-click="openDetails"
            highlight-current-row
            :header-cell-style="{
              background: '#e6e6e6',
              color: '#000',
            }"
            style="width: 100%"
            border
          >
            <el-table-column
              type="index"
              width="50"
              label="序号"
              align="center"
            >
            </el-table-column>
            <el-table-column prop="name" label="探望姓名" align="center">
            </el-table-column>
            <el-table-column prop="typeName" label="类型" align="center">
            </el-table-column>
            <el-table-column prop="states" label="状态" align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.states == 1">已完成</span>
                <span v-if="scope.row.states == 0">未完成</span>
              </template>
            </el-table-column>
            <el-table-column prop="visitTime" label="回访时间" align="center">
            </el-table-column>
            <el-table-column label="操作" align="center" width="200px">
              <template slot-scope="scope">
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="查看"
                  placement="top-start"
                >
                  <button
                    style="color: #000"
                    class="iconfont icon-chakan tabBtn"
                    @click="look2('查看', '探望记录', scope.row)"
                  ></button>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="10"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total1"
          ></el-pagination>
        </div>

        <!-- 反馈问题 -->
        <div class="dialog_content_pane" v-show="stepIndex == 4">
          <el-table
            :data="tableDate3"
            tooltip-effect="dark"
            @row-click="openDetails"
            highlight-current-row
            :header-cell-style="{
              background: '#e6e6e6',
              color: '#000',
            }"
            style="width: 100%"
            border
          >
            <el-table-column
              type="index"
              width="50"
              label="序号"
              align="center"
            >
            </el-table-column>
            <el-table-column prop="feedback" label="反馈内容" align="center">
            </el-table-column>
            <!-- <el-table-column
                            prop="returnStatus"
                            label="图片"
                            align="center"
                        >
                        </el-table-column> -->
            <el-table-column prop="updateDate" label="反馈时间" align="center">
            </el-table-column>
            <el-table-column
              prop="feedbackstate"
              label="指派状态"
              align="center"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <span v-if="scope.row.feedbackstate == 0">未指派</span>
                <span v-if="scope.row.feedbackstate == 1">已指派</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="200px">
              <template slot-scope="scope">
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="查看"
                  placement="top-start"
                >
                  <button
                    v-if="scope.row.feedbackstate == 1"
                    style="color: #000"
                    class="el-icon-tickets tabBtn"
                    @click="look3('查看', scope.row)"
                  ></button>
                </el-tooltip>
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="指派"
                  placement="top-start"
                >
                  <button
                    v-if="scope.row.feedbackstate == 0"
                    style="color: #000"
                    class="el-icon-thumb tabBtn"
                    @click="look3('指派', scope.row)"
                  ></button>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            @size-change="handleSizeChange3"
            @current-change="handleCurrentChange3"
            :current-page="currentPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="10"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total1"
          ></el-pagination>
        </div>

        <div
          slot="footer"
          v-if="
            dialogTitle == '新增' ||
            dialogTitle == '信息回访' ||
            dialogTitle == '编辑'
          "
        >
          <el-button type="primary" @click="submitForm">确定 </el-button>
          <el-button @click="dialogVisible = false">取消</el-button>
        </div>
      </el-dialog>

      <!-- 信息回访记录查看 -->
      <el-dialog title="查看" :visible.sync="dialogVisible2" width="990px">
        <el-form
          ref="returnVisitForm"
          class="return_visit_form"
          :model="returnVisitForm1"
          @close="returnVisitFormClose"
          label-width="120px"
        >
          <template v-for="(item, index) in currentZfEvaluateContentLis">
            <div :key="index">
              <el-form-item label="问题：">
                <el-input
                  v-model="item.questionName"
                  placeholder="请输入问题"
                ></el-input>
              </el-form-item>
              <el-form-item label="回复选择：">
                <el-radio-group v-model="item.replySelection">
                  <el-radio label="0">是</el-radio>
                  <el-radio label="1">否</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="原因：" placeholder="请输入内容">
                <el-input
                  type="textarea"
                  :rows="3"
                  v-model="item.reason"
                ></el-input>
              </el-form-item>
            </div>
          </template>
          <el-form-item label="其他：" placeholder="请输入内容">
            <el-input type="textarea" :rows="3" v-model="feedback"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" style="margin-button: 10px">
          <el-button type="primary" @click="save1">确定</el-button>
          <el-button @click="dialogVisible2 = false">取消</el-button>
        </div>
      </el-dialog>

      <!-- 探望查看ww -->
      <el-dialog :title="title1" :visible.sync="dialogVisible3" width="800px">
        <el-steps
          :active="stepIndex1"
          align-center
          v-show="stepIndex1 != 0"
          v-if="visitShow == true"
        >
          <el-step
            ><span slot="icon" @click="changeProgress(1)"
              >基本信息</span
            ></el-step
          >
          <el-step
            ><span slot="icon" @click="changeProgress(2)">{{
              stepTitle
            }}</span></el-step
          >
        </el-steps>
        <!-- 基本信息 -->
        <div
          class="dialog_content_pane"
          v-show="stepIndex1 == 1"
          v-if="visitShow == true"
        >
          <el-form
            label-width="100px"
            :model="formData"
            ref="formData"
            :disabled="visitShow == true"
          >
            <el-row>
              <el-col :span="24">
                <el-row
                  style="
                    display: flex;
                    align-items: center;
                    margin-bottom: 20px;
                  "
                >
                  <el-col :span="18">
                    <el-row class="dialog_form_left">
                      <el-col :span="11">
                        <el-form-item label="姓名：" prop="name">
                          <el-select
                            v-model="formData.customerName"
                            filterable
                            remote
                            style="width: 100%"
                            placeholder="请输入关键词"
                            :disabled="
                              dialogTitle === '查看' || dialogTitle === '编辑'
                            "
                            :remote-method="remoteMethod"
                            @change="handleSelect"
                            @click.native="clearForm"
                            :loading="loading"
                          >
                            <el-option
                              v-for="item in options"
                              :key="item.id"
                              :label="item.customerName"
                              :value="item.id"
                            >
                            </el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col :span="11" :offset="1">
                        <el-form-item label="年龄：" prop="age">
                          <el-input v-model="formData.age"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="11">
                        <el-form-item label="身份证号：" prop="idCard">
                          <el-select
                            v-model="formData.idCard"
                            filterable
                            remote
                            style="width: 100%"
                            placeholder="请输入关键词"
                            :disabled="
                              dialogTitle === '查看' || dialogTitle === '编辑'
                            "
                            :remote-method="remoteMethod1"
                            @change="handleSelect"
                            @click.native="clearForm1"
                            :loading="loading"
                          >
                            <el-option
                              v-for="item in options"
                              :key="item.id"
                              :label="item.idCard"
                              :value="item.id"
                            >
                            </el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col :span="11" :offset="1">
                        <el-form-item label="性别：">
                          <el-select
                            v-model="formData.gender"
                            placeholder="请选择性别"
                            style="width: 100%"
                          >
                            <el-option label="男" value="0"></el-option>
                            <el-option label="女" value="1"></el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col :span="11">
                        <el-form-item label="出生年月：">
                          <el-date-picker
                            v-model="formData.birthday"
                            type="date"
                            placeholder="选择日期"
                            value-format="yyyy-MM"
                            style="width: 100%"
                          >
                          </el-date-picker>
                        </el-form-item>
                      </el-col>
                      <el-col :span="11" :offset="1">
                        <el-form-item label="手机号：">
                          <el-input v-model="formData.phone"></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item prop="photo" class="photoFrom">
                      <div class="upImg">
                        <el-upload
                          :action="actionUrl"
                          :show-file-list="false"
                          :on-success="handleAvatarSuccess"
                          :before-upload="beforeAvatarUpload"
                        >
                          <div class="avatar" v-if="formData.photo">
                            <img :src="formData.photo" />
                          </div>
                          <div v-else style="text-align: center; width: 178px">
                            <i
                              class="el-icon-plus avatar_uploader avatar-uploader-icon"
                            ></i>
                          </div>
                        </el-upload>
                      </div>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
            <el-form-item label="民族：" prop="nation">
              <el-select
                v-model="formData.nation"
                placeholder="请选择"
                style="width: 100%"
              >
                <el-option
                  v-for="item in nation"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="生活区域：" prop="lifeArea">
              <el-select
                v-model="formData.lifeArea"
                placeholder="请选择"
                style="width: 100%"
              >
                <el-option label="农村" value="2"></el-option>
                <el-option label="城市" value="1"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="老人类别：" prop="elderlyBelongCategory">
              <el-select
                v-model="formData.elderlyBelongCategory"
                placeholder="请选择"
                style="width: 100%"
              >
                <el-option
                  v-for="(item, index) in oldtypeLits"
                  :key="index"
                  :label="item.dictLabel"
                  :value="item.dictCode"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="用户类型：" prop="minzhengIndex">
              <el-select
                v-model="formData.minzhengIndex"
                placeholder="请选择用户类型"
                style="width: 100%"
              >
                <el-option
                  v-for="(item, index) in usertypeList"
                  :key="index"
                  :label="item.dictLabel"
                  :value="item.dictCode"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="居住地址：">
              <el-row>
                <el-col :span="4">
                  <el-form-item>
                    <el-select
                      v-model="formData.provinceId"
                      placeholder="请选择省"
                      @change="handleProvince"
                      style="width: 100%"
                    >
                      <el-option
                        v-for="(item, index) in provinceList"
                        :key="index"
                        :label="item.name"
                        :value="item.adcode"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="4" :offset="1">
                  <el-select
                    v-model="formData.cityId"
                    placeholder="请选择市"
                    @change="handleCity"
                    style="width: 100%"
                  >
                    <el-option
                      v-for="(item, index) in cityList"
                      :key="index"
                      :label="item.name"
                      :value="item.adcode"
                    >
                    </el-option>
                  </el-select>
                </el-col>
                <el-col :span="4" :offset="1">
                  <el-select
                    v-model="formData.areaId"
                    placeholder="请选择区"
                    @change="handleArea"
                    style="width: 100%"
                  >
                    <el-option
                      v-for="(item, index) in areaList"
                      :key="index"
                      :label="item.name"
                      :value="item.adcode"
                    >
                    </el-option>
                  </el-select>
                </el-col>
                <el-col :span="4" :offset="1">
                  <el-select
                    v-model="formData.streetId"
                    @change="streetChange"
                    placeholder="请选择街道"
                  >
                    <el-option
                      v-for="(item, index) in streetList"
                      :key="index"
                      :label="item.addName"
                      :value="item.addCode"
                    >
                    </el-option>
                  </el-select>
                </el-col>
                <el-col :span="4" :offset="1">
                  <el-select
                    v-model="formData.communityId"
                    placeholder="请选择社区"
                    @change="handleCommunityChange"
                  >
                    <el-option
                      v-for="item in communityList"
                      :key="item.id"
                      :label="item.address"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </el-col>
              </el-row>
              <el-input
                v-model="formData.address"
                style="margin-top: 12px"
              ></el-input>
            </el-form-item>
            <el-row style="margin-top: 20px">
              <el-col :span="6">
                <div class="map_left">
                  <p v-for="(item, index) in streetList" :key="index">
                    {{ item.addName }}
                  </p>
                </div>
              </el-col>
              <el-col :span="17" :offset="1">
                <div
                  class="map_right"
                  id="container1"
                  style="width: 100%; height: 400px"
                ></div>
              </el-col>
            </el-row>
          </el-form>
        </div>

        <!-- 探望内容 -->
        <div class="dialog_content_pane" v-show="stepIndex1 == 2" v-if="true">
          <!-- 上门回访 -->
          <div v-if="twnrShow">
            <table
              ref="print"
              border="1"
              :model="addForm1"
              cellspacing="0"
              cellpadding="0"
              style="border-collapse: collapse; text-align: center; width: 100%"
            >
              <tr style="height: 60px">
                <td colspan="8">农村特殊困难老年人走访、探望情况登记表</td>
              </tr>
              <tr style="height: 60px">
                <td colspan="2" width="25%" style="background: #e0d6e0">
                  被探访人姓名
                </td>
                <td colspan="2">
                  {{ addForm1.customerName }}
                  <!-- 李倾 -->
                </td>
                <td colspan="2" style="background: #e0d6e0">探访人姓名</td>
                <td colspan="2">
                  {{ addForm1.serverPersoName }}
                </td>
              </tr>
              <tr style="height: 60px">
                <td colspan="2" style="background: #e0d6e0; width: 50%">
                  探访时间
                </td>
                <td colspan="2" style="width: 50%">
                  {{ addForm1.visitTime }}
                  <!-- 2020-10-31 15:30 -->
                </td>
                <td colspan="2" style="background: #e0d6e0">探访地点</td>
                <td colspan="2">
                  {{ addForm1.address }}
                </td>
              </tr>
              <tr style="height: 100px">
                <td colspan="2" style="background: #e0d6e0">老人服务需求</td>
                <td colspan="6">
                  <el-checkbox-group v-model="addForm1.esElderlyDemand">
                    <el-checkbox label="0">安全巡查 </el-checkbox>
                    <el-checkbox label="1">生活资料 </el-checkbox>
                    <el-checkbox label="2">文化娱乐 </el-checkbox>
                    <el-checkbox label="3">精神慰藉 </el-checkbox>
                    <el-checkbox label="4">其他服务 </el-checkbox>
                  </el-checkbox-group>
                </td>
              </tr>
              <tr style="height: 100px">
                <td colspan="2" style="background: #e0d6e0">
                  探视活动情况记录
                </td>
                <td colspan="6">
                  {{ addForm1.esVisitingRecord }}
                </td>
              </tr>
              <tr style="height: 100px">
                <td colspan="2" style="background: #e0d6e0">健康状况</td>
                <td colspan="6">
                  {{ addForm1.esHealth == 0 ? "有" : "无" }}
                </td>
              </tr>
              <tr style="height: 100px">
                <td colspan="2" style="background: #e0d6e0">老人自理类别</td>
                <td colspan="6">
                  <el-checkbox-group
                    v-model="addForm1.elderlyCategory"
                    style="font-size: 30px"
                  >
                    <el-checkbox label="0">自理 </el-checkbox>
                    <el-checkbox label="1">失能 </el-checkbox>
                    <el-checkbox label="2">半失能 </el-checkbox>
                    <el-checkbox label="3">失智 </el-checkbox>
                    <el-checkbox label="4">轻度依赖 </el-checkbox>
                    <el-checkbox label="5">重度依赖 </el-checkbox>
                    <el-checkbox label="6">不能自理 </el-checkbox>
                  </el-checkbox-group>
                </td>
              </tr>
              <tr style="height: 100px" v-if="addForm1.esHealth == 0">
                <td colspan="2" style="background: #e0d6e0">听力状况</td>
                <td colspan="6">
                  <el-radio-group type="kind" v-model="addForm1.hearingStatus">
                    <el-radio v-model="addForm.hearingStatus" label="0"
                      >良好
                    </el-radio>
                    <el-radio v-model="addForm.hearingStatus" label="1"
                      >一般
                    </el-radio>
                    <el-radio v-model="addForm.hearingStatus" label="2"
                      >很大声才能听见
                    </el-radio>
                    <el-radio v-model="addForm.hearingStatus" label="3"
                      >听不见
                    </el-radio>
                  </el-radio-group>
                </td>
              </tr>
              <tr style="height: 200px" v-if="addForm1.esHealth == 0">
                <td colspan="2" style="background: #e0d6e0">病史</td>
                <td colspan="6">
                  <el-checkbox-group
                    v-model="addForm1.medicalHistory"
                    style="font-size: 30px"
                  >
                    <el-checkbox label="0">健康 </el-checkbox>
                    <el-checkbox label="1">高血压 </el-checkbox>
                    <el-checkbox label="2">糖尿病 </el-checkbox>
                    <el-checkbox label="3">冠心病 </el-checkbox>
                    <el-checkbox label="4">恶性肿瘤 </el-checkbox>
                    <el-checkbox label="5">结核病 </el-checkbox>
                    <el-checkbox label="6">肝炎 </el-checkbox>
                    <el-checkbox label="7">脑卒中 </el-checkbox>
                    <el-checkbox label="8">精神疾病 </el-checkbox>
                    <el-checkbox label="9">脑血栓 </el-checkbox>
                    <el-checkbox label="10">慢性阻塞性肺疾病 </el-checkbox>
                    <el-checkbox label="11">慢性支气管炎 </el-checkbox>
                    <el-checkbox label="12">帕金森综合症 </el-checkbox>
                    <el-checkbox label="13">腰间盘突出 </el-checkbox>
                    <el-checkbox label="14">心脏病 </el-checkbox>
                    <el-checkbox label="15">肺气肿 </el-checkbox>
                    <el-checkbox label="16">风湿病 </el-checkbox>
                    <el-checkbox label="17">脑中风 </el-checkbox>
                    <el-checkbox label="18">高脂血症 </el-checkbox>
                    <el-checkbox label="19">哮喘 </el-checkbox>
                    <el-checkbox label="20">意外伤害 </el-checkbox>
                    <el-checkbox label="21">其他 </el-checkbox>
                  </el-checkbox-group>
                </td>
              </tr>
              <tr style="height: 100px">
                <td colspan="2" style="background: #e0d6e0">图片</td>
                <td colspan="6">
                  <!-- {{name}} -->
                  <div
                    style="
                      height: 100px;
                      width: 570px;
                      display: flex;
                      padding-left: 10%;
                    "
                  >
                    <div
                      style="width: 20%; margin: auto 10px"
                      v-for="(item, index) in inmageList"
                      :key="index"
                    >
                      <el-image v-if="item" :src="item"></el-image>
                    </div>
                    <!-- src="https://fuss10.elemecdn.com/a/3f/3302e58f9a181d2509f3dc0fa68b0jpeg.jpeg" -->
                  </div>
                </td>
              </tr>
              <tr style="height: 60px">
                <td colspan="2" style="background: #e0d6e0">
                  被走访、探望人满意度情况
                </td>
                <td colspan="6">
                  {{ addForm1.esSatisfied == 1 ? "不满意" : "满意" }}
                </td>
              </tr>
            </table>
            <el-button
              type="primary"
              style="display: block; margin: 20px auto"
              @click="dy"
              >打印
            </el-button>
          </div>
          <div v-if="!twnrShow">
            <el-form
              ref="returnVisitForm"
              class="return_visit_form"
              :model="returnVisitForm"
              label-width="120px"
            >
              <template v-for="(item, index) in currentZfEvaluateContentLis">
                <div :key="index">
                  <el-form-item label="问题：">
                    <el-input
                      disabled
                      v-model="item.questionName"
                      placeholder="请输入问题"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="回复选择：">
                    <el-radio-group v-model="item.replySelection">
                      <el-radio label="0">是</el-radio>
                      <el-radio label="1">否</el-radio>
                    </el-radio-group>
                  </el-form-item>
                  <el-form-item label="原因：" placeholder="请输入内容">
                    <el-input
                      type="textarea"
                      :rows="3"
                      v-model="item.reason"
                    ></el-input>
                  </el-form-item>
                </div>
              </template>
              <el-form-item label="其他：" placeholder="请输入内容">
                <el-input
                  type="textarea"
                  :rows="3"
                  v-model="returnVisitForm.feedback"
                ></el-input>
              </el-form-item>
            </el-form>
          </div>
        </div>
        <div slot="footer" style="margin-button: 10px" v-if="check == true">
          <el-button type="primary" @click="save2">确定</el-button>
          <el-button @click="dialogVisible3 = false">取消</el-button>
        </div>
      </el-dialog>

      <!-- 指派 -->
      <el-dialog
        :title="dialogTitle4"
        :visible.sync="dialogVisible4"
        width="800px"
      >
        <el-form
          label-width="130px"
          ref="assign"
          :model="assign"
          :rules="assignRules"
        >
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="反映人：" prop="customerName">
                <el-input
                  v-model="assign.customerName"
                  placeholder="请输入"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="手机号：">
                <el-input
                  v-model="assign.phone"
                  placeholder="请输入"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="反映渠道：">
                <el-input
                  v-model="assign.reflectChannelName"
                  placeholder="请输入"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="反馈时间：" prop="updateDate">
                <el-date-picker
                  v-model="assign.updateDate"
                  type="datetime"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  placeholder="选择日期"
                  style="width: 100%"
                  disabled
                >
                </el-date-picker>
                <!-- <el-input v-model="assign.feedbackTime"></el-input> -->
              </el-form-item>
            </el-col>
          </el-row>

          <el-form-item label="居住地址：">
            <el-input
              v-model="assign.address"
              placeholder="请输入"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="反馈内容：">
            <el-input
              v-model="assign.feedback"
              type="textarea"
              :rows="3"
              disabled
            ></el-input>
          </el-form-item>

          <el-form-item label="图片：" v-if="assign.photo != null">
            <div class="avatar">
              <img
                :src="item"
                v-for="(item, index) in assign.photo"
                :key="index"
              />
            </div>
          </el-form-item>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="选择部门：" prop="serverStationId">
                <el-select
                  v-model="assign.serverStationId"
                  placeholder="请选择部门"
                  style="width: 100%"
                  @change="selectDepart"
                  :disabled="dialogTitle4 == '查看'"
                >
                  <el-option
                    v-for="(item, index) in departmentDate"
                    :label="item.departmentName"
                    :value="item.id"
                    :key="index"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="选择人员：" prop="serverPersonId">
                <el-select
                  v-model="assign.serverPersonId"
                  placeholder="请选择人员"
                  @change="selectPersont"
                  style="width: 100%"
                  :disabled="dialogTitle4 == '查看'"
                >
                  <el-option
                    v-for="(item, index) in personIdOptions"
                    :label="item.personName"
                    :value="item.id"
                    :key="index"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="手机号：">
                <el-input
                  disabled
                  v-model="assign.serverPersonPhone"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer" v-if="dialogTitle4 == '指派'">
          <el-button type="primary" @click="save">确定</el-button>
          <el-button @click="dialogVisible4 = false">取消</el-button>
        </div>
      </el-dialog>

      <!-- 信息回访进度 -->
      <el-dialog
        :title="dialogTitle1"
        :visible.sync="dialogVisible5"
        width="800px"
      >
        <div v-if="schedule">
          <el-table
            :data="tableDate1"
            tooltip-effect="dark"
            @row-click="openDetails"
            highlight-current-row
            :header-cell-style="{
              background: '#e6e6e6',
              color: '#000',
            }"
            style="width: 100%"
            border
          >
            <el-table-column
              type="index"
              width="50"
              label="序号"
              align="center"
            >
            </el-table-column>
            <el-table-column prop="customerName" label="姓名" align="center">
            </el-table-column>
            <el-table-column prop="age" label="年龄" align="center">
            </el-table-column>
            <el-table-column prop="gender" label="性别" align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.gender == 0">男</span>
                <span v-if="scope.row.gender == 1">女</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="minzhengIndex"
              min-width="200"
              label="用户类型"
              align="center"
            >
              <template slot-scope="scope">
                <span v-for="(item, index) in usertypeList" :key="index"
                  ><span v-if="scope.row.minzhengIndex == item.dictCode">{{
                    item.dictLabel
                  }}</span></span
                >
              </template>
            </el-table-column>
            <el-table-column
              min-width="200"
              label="信息回访时间"
              align="center"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.startTime }}~{{ scope.row.endTime }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="states" label="状态" align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.states == 1">已完成</span>
                <span v-if="scope.row.states == 0">未完成</span>
              </template>
            </el-table-column>
            <el-table-column
              label="操作"
              fixed="right"
              align="center"
              width="200"
              >tan
              <template slot-scope="scope">
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="查看"
                  placement="top-start"
                >
                  <button
                    v-if="check != true"
                    style="color: #000"
                    class="iconfont icon-chakan tabBtn"
                    @click="look2('查看', '走访进度', scope.row)"
                  ></button>
                </el-tooltip>
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="回访"
                  placement="top-start"
                >
                  <button
                    v-if="check == true"
                    style="color: #000"
                    class="iconfont icon-bianji3 tabBtn"
                    @click="look2('回访', '走访进度', scope.row)"
                  ></button>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            @size-change="handleSizeChange1"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="10"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total3"
          ></el-pagination>
        </div>
        <!-- 走访探望进度 -->
        <div v-if="!schedule">
          <el-table
            :data="tableDate4"
            tooltip-effect="dark"
            @row-click="openDetails"
            highlight-current-row
            :header-cell-style="{
              background: '#e6e6e6',
              color: '#000',
            }"
            style="width: 100%"
            border
          >
            <el-table-column
              type="index"
              width="50"
              label="序号"
              align="center"
            >
            </el-table-column>
            <el-table-column prop="customerName" label="姓名" align="center">
            </el-table-column>
            <el-table-column prop="age" label="年龄" align="center">
            </el-table-column>
            <el-table-column prop="gender" label="性别" align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.gender == 0">男</span>
                <span v-if="scope.row.gender == 1">女</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="minzhengIndex"
              label="用户类型"
              min-width="200"
              align="center"
            >
              <template slot-scope="scope">
                <span v-for="(item, index) in usertypeList" :key="index"
                  ><span v-if="scope.row.minzhengIndex == item.dictCode">{{
                    item.dictLabel
                  }}</span></span
                >
              </template>
            </el-table-column>
            <el-table-column
              min-width="200"
              label="走访探望时间"
              align="center"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.startTime }}~{{ scope.row.endTime }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="states" label="状态" align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.states == 0">未完成</span>
                <span v-if="scope.row.states == 1">已完成</span>
              </template>
            </el-table-column>
            <el-table-column
              label="操作"
              fixed="right"
              align="center"
              width="200"
            >
              <template slot-scope="scope">
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="查看"
                  placement="top-start"
                >
                  <button
                    style="color: #000"
                    class="iconfont icon-chakan tabBtn"
                    @click="look2('查看', '走访进度', scope.row)"
                  ></button>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            @size-change="handleSizeChange4"
            @current-change="handleCurrentChange4"
            :current-page="currentPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="10"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total2"
          ></el-pagination>
        </div>
      </el-dialog>
      <!-- 清除手机号座机号 -->
      <el-dialog title="是否清除" width="300px" :visible.sync="dialogVisible6">
        <el-checkbox-group v-model="isphone">
          <el-checkbox label="清除手机号"></el-checkbox>
          <el-checkbox label="清除座机号"></el-checkbox>
        </el-checkbox-group>
        <div slot="footer">
          <el-button type="primary" @click="saveClear">确定</el-button>
          <el-button @click="Clears">取消</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import common from "../../../utils/common.js"
import request from "@/utils/request.js"
import AMap from "AMap" // 引入高德地图
import baseURL from "@/api/baseURL"
// import '@/utils/addToolbar'
import { discriCard, chekCode, chekPhone } from "@/views/elderManage/util.js"

export default {
  data() {
    var checkIdCode = (rule, value, callback) => {
      if (!chekCode(value)) {
        return callback(new Error("身份证号格式错误"))
      }
      callback()
    }

    return {
      addForm: {
        prizeList: [],
        shengId: null,
        shiId: null,
        quId: null,
        jiedaoId: null,
        shequId: null,
        photo: [],
        nation: "", //民族
      },
      isphone: [],
      usertypeList: [],
      defaultProps: {
        children: "children",
        label: "label",
      },
      orgList: [],
      arrOrgList: [],
      // 表单验证
      formDateRules: {
        // 姓名
        oldId: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        // 身份证
        idCard: [
          {
            required: true,
            message: "请输入身份证号",
            trigger: "blur",
          },
          // { validator: checkIdCode, trigger: "blur" },
        ],

        minzhengIndex: [
          {
            required: true,
            message: "请输入用户类型",
            trigger: "blur",
          },
        ],
      },
      dialogTitle4: "",
      title1: "",
      stepTitle: "",
      schedule: false,
      twnrShow: false,
      visitShow: false,
      visitShow1: false,
      // 图片预览
      dialogImageUrl: "",
      // 上传图片地址
      actionUrl: baseURL + "/ypt/controller/uploadController/info/uploadPhoto",
      imageUrl: "",
      selectedData: [],
      // 筛选数据功能按钮初始值
      checkList: [
        "序号",
        "姓名",
        "年龄",
        "性别",
        "手机号码",
        "老人类别",
        "用户类型",
        "居住地址",
        "信息回访进度",
        "走访探望进度",
        "操作",
      ],

      stepIndex: 1, //当前步骤下标
      stepIndex1: 1, //走访进度步骤下标
      formData: {
        //基本信息
        id: "",
        name: "", //姓名
        gender: "", //性别
        phone: "", //联系方式
        idCard: "", //身份证号
        age: "", //年龄
        birthday: "", // 出生年月
        minzhengIndex: "", //老人类型
        provinceId: "", //省
        cityId: "", //市
        areaId: "", //区
        streetId: "", //街道
        communityId: "", //社区
        address: "", //居住地址
        photo: "", //图片
        nation: "", //民族
        liveCondition: "", //居住情况
        economicSource: [], //经济来源
        serviceStation: null, //所属机构
        lifeArea: "",
        elderlyBelongCategory: "",
        orgName: "",
        familyCall: "",
        // economicSource:'',
      },
      returnVisitForm: {
        feedback: "",
      },
      returnVisitForm1: [],
      feedback: "",
      currentRow: null,

      returnLookForm: {
        // 回访信息查看
        questionName1: "",
        replySelection1: "",
        reason1: "",
        questionName2: "",
        replySelection2: "",
        reason2: "",
        other: "",
      },
      // 指派
      assign: {
        person: "",
        phone: "",
        feedbackType: "",
        feedbackTime: "",
        isFeedbackName: "1",
        photo: [],
        personId: "",
        departmentId: "",
        isRecord: "1",
        address: "",
        feedback: "",
        name: "",
        personPhone: "",
        id: "",
      },
      // 表单测试数据
      tableDate: [],
      tableDate1: [],
      tableDate4: [],
      tableDate2: [],
      tableDate3: [],
      nation: [
        "汉族",
        "蒙古族",
        "回族",
        "藏族",
        "维吾尔族",
        "苗族",
        "彝族",
        "壮族",
        "布依族",
        "朝鲜族",
        "满族",
        "侗族",
        "瑶族",
        "白族",
        "土家族",
        "哈尼族",
        "哈萨克族",
        "傣族",
        "黎族",
        "傈僳族",
        "佤族",
        "畲族",
        "高山族",
        "拉祜族",
        "水族",
        "东乡族",
        "纳西族",
        "景颇族",
        "柯尔克孜族",
        "土族",
        "达斡尔族",
        "仫佬族",
        "羌族",
        "布朗族",
        "撒拉族",
        "毛南族",
        "仡佬族",
        "锡伯族",
        "阿昌族",
        "普米族",
        "塔吉克族",
        "怒族",
        "乌孜别克族",
        "俄罗斯族",
        "鄂温克族",
        "德昂族",
        "保安族",
        "裕固族",
        "京族",
        "塔塔尔族",
        "独龙族",
        "鄂伦春族",
        "赫哲族",
        "门巴族",
        "珞巴族",
        "基诺族",
      ],

      addForm: {
        health: "",
        serviceDemand: [],
        selfCare: [],
        hraring: "",
        medicalHistory: [],
      },
      inmageList: [],
      addForm1: {
        name: "",
        serverPersoName: "",
        health: "0",
        visitPhoto: [],
        esElderlyDemand: [],
        elderlyCategory: [],
        medicalHistory: [],
        hearingStatus: "",
      },
      elderlyDemand1: [],
      provinceList: [], //省列表
      cityList: [], //市列表
      areaList: [], //区列表
      streetList: [], //街道列表
      communityList: [], //社区列表
      polygons: [],
      optionsType: [],
      // 图片弹框
      dialogVisible1: false,
      // 查看弹框
      footShow: false,
      see: false,
      // 信息回访记录查看
      dialogVisible2: false,
      // 上门探望查看
      dialogVisible3: false,
      // 指派
      dialogVisible4: false,
      // 走访进度
      dialogVisible5: false,
      dialogVisible6: false,
      // 筛选按钮
      no1: true,
      no2: true,
      no3: true,
      no4: true,
      no5: true,
      no6: true,
      no7: true,
      no8: true,
      no9: true,
      no10: true,
      no12: true,

      // 搜素条件是否显示
      quanbu: true,
      cardIn: false,
      currentPage: 1, //默认展示第一页
      total: 0, //总数据
      total1: 0,
      total2: 0,
      total3: 0,
      searchValue: true,
      showSlide: true,
      editableTabsValue: "1",
      tabIndex: 1,
      input: "",
      value: "",
      valueSq: "",
      multipleSelection: [],
      pageNo: 1,
      pageSize: 10,
      oldtypeLits: [],
      pageConfig: {
        pageSize: 10,
        total: 0,
        pageNo: 1,
      },
      // 搜索
      form: {
        name: "", //姓名
        provinceId: "", //居住地址
        cityId: "", //居住地址
        areaId: "", //居住地址
        streetId: "", //居住地址
        communityId: "", //居住地址
        lifeArea: "", //生活区域
        elderlyBelongCategory: "", //用户类型
        pageNo: 1,
        pageSize: 10,
        minzhengIndex: "",
        customerName: "",
      },
      dialogVisible: false,
      dialogTitle: "",
      dialogTitle1: "",
      zfxxindex: "", //走访、信息区分
      myMap: null,
      isMap: true,
      loading: false,
      options: [],
      check: false, //判断是否编辑
      huodeId: "",
      departmentDate: [], //部门列表
      personIdOptions: [], //人员列表
      currentZfEvaluateContentLis: [],
      tableId: "",
      normalInfo: {},
      assignRules: {
        serverStationId: [
          {
            required: true,
            message: "部门不能为空",
            trigger: "blur",
          },
        ],
        serverPersonId: [
          {
            required: true,
            message: "人员不能为空",
            trigger: "blur",
          },
        ],
      },
    }
  },
  inject: ["reload"], //注入
  created() {
    //this.getProvince()
    this.getOrg()
    this.getServiceStationList()
    this.departmentlist()
    this.gettypeList()
    this.showlist()
    this.getusertypeList()
  },
  methods: {
    getusertypeList() {
      let query = {
        pageNum: 1,
        pageSize: 999,
        dictType: "visiting_user_type",
      }
      this.$http
        .request({
          url: "/rbac/system/dict/data/list",
          method: "get",
          params: query,
        })
        .then((res) => {
          if (res.code == 200) {
            if (res.rows != null) {
              this.usertypeList = res.rows
              this.usertypeList.forEach((item) => {
                item.dictCode = String(item.dictCode)
              })
            }
          }
        })
    },
    getchangeList(query, query1) {
      this.$http
        .request({
          url: "/ypt/admin/all/customer/info/findListAccurately",
          method: "POST",
          data: {
            pageNo: 1,
            pageSize: 99,
            customerName: query,
            idCard: query1,
          },
        })
        .then((res) => {
          if (res.code == 200) {
            if (res.content != null) {
              this.options = res.content.list
            } else {
              this.options = []
            }
            this.loading = false
          }
        })
    },
    remoteMethod(query) {
      if (query !== "") {
        this.loading = true
        this.getchangeList(query)
      } else {
        this.options = []
      }
    },
    remoteMethod1(query) {
      if (query !== "") {
        this.loading = true
        this.getchangeList("", query)
      } else {
        this.options = []
      }
    },
    async handleSelect(val) {
      this.options.forEach(async (item) => {
        if (item.id == val) {
          this.formData.oldId = val
          this.$set(this.formData, "customerName", item.customerName)
          this.$set(this.formData, "idCard", item.idCard)
          this.$set(this.formData, "phone", item.phone)
          this.$set(this.formData, "gender", item.gender)
          this.$set(this.formData, "age", item.age)
          this.$set(this.formData, "photo", item.photo)
          this.$set(this.formData, "nation", item.nation)
          this.$set(this.formData, "familyCall", item.familyCall)

          if (item.lifeArea) {
            this.$set(this.formData, "lifeArea", item.lifeArea)
          } else {
            this.formData.lifeArea = ""
          }
          if (item.economicSource) {
            this.$set(this.formData, "economicSource", item.economicSource)
            this.formData.economicSource = item.economicSource.split(",")
          } else {
            this.formData.economicSource = []
          }
          if (item.liveCondition) {
            this.$set(this.formData, "liveCondition", item.liveCondition)
          } else {
            this.formData.liveCondition = ""
          }
          this.$set(this.formData, "serviceStation", item.serviceStation)
          if (item.elderlyBelongCategory) {
            item.elderlyBelongCategory = item.elderlyBelongCategory.toString()
            this.$set(
              this.formData,
              "elderlyBelongCategory",
              item.elderlyBelongCategory
            )
          }
          this.$set(this.formData, "birthday", item.birthday)
          this.$set(this.formData, "provinceId", item.provinceId)
          this.$set(this.formData, "cityId", item.cityId)
          this.$set(this.formData, "areaId", item.areaId)
          this.$set(this.formData, "streetId", item.streetId)
          this.$set(this.formData, "communityId", item.communityId)
          this.$set(this.formData, "address", item.address)
          this.$set(this.formData, "longitude", item.longitude)
          this.$set(this.formData, "latitude", item.latitude)
          this.$set(this.formData, "liveCondition", item.liveCondition)
          this.$set(this.formData, "minzhengIndex", "")
          this.formData.lifeArea = String(this.formData.lifeArea)
          if (
            this.formData.provinceId == null ||
            this.formData.provinceId == "0"
          ) {
            this.formData.provinceId = ""
            return
          }
          if (this.formData.cityId == null || this.formData.cityId == "0") {
            this.formData.cityId = ""
            return
          }
          if (this.formData.areaId == null || this.formData.areaId == "0") {
            this.formData.areaId = ""
            return
          }
          if (this.formData.streetId == null || this.formData.streetId == "0") {
            this.formData.streetId = ""
            return
          }
          if (
            this.formData.communityId == null ||
            this.formData.communityId == "0"
          ) {
            this.formData.communityId = ""
            return
          }
          let provice = await this.getDistricts()
          this.provinceList = provice.districtList
          this.formData.provinceId = String(this.formData.provinceId)
          if (!this.formData.provinceId) return
          let city = await this.getDistricts(this.formData.provinceId)
          this.cityList = city.districtList
          if (!this.formData.cityId) return
          this.formData.cityId = String(this.formData.cityId)
          let area = await this.getDistricts(this.formData.cityId)
          this.areaList = area.districtList
          if (!this.formData.areaId) return
          this.formData.areaId = String(this.formData.areaId)
          let streetList = await this.getStreetList(this.formData.areaId)
          this.streetList = streetList
          if (!this.formData.streetId) return
          this.formData.streetId = String(this.formData.streetId)
          let communityList = await this.getCommityList(this.formData.streetId)
          this.communityList = communityList
          this.formData.communityId = Number(this.formData.communityId) //社区

          this.loadmap("container")
          setTimeout(() => {
            this.potintMap()
          }, 500)
          this.$forceUpdate()
        }
      })
    },
    //监控姓名是否为空
    clearForm(val) {
      if (val) {
        if (this.dialogTitle == "新增") {
          this.formData = {}
        }
      }
    },
    //监控身份证是否为空
    clearForm1(val) {
      if (val) {
        if (this.dialogTitle == "新增") {
          this.formData = {}
        }
      }
    },
    // 五级联动地图方法
    async handleProvince(val) {
      this.cityList = []
      this.areaList = []
      this.streetList = []
      this.communityList = []
      this.formData.cityId = ""
      this.formData.areaId = ""
      this.formData.streetId = ""
      this.formData.communityId = ""
      this.formData.address = ""
      let city = await this.getDistricts(val)
      this.cityList = city.districtList
      // this.joinAddress()
    },

    //市级地址发生改变
    async handleCity(val) {
      this.areaList = []
      this.streetList = []
      this.communityList = []
      this.formData.areaId = ""
      this.formData.streetId = ""
      this.formData.communityId = ""
      this.formData.address = ""
      let area = await this.getDistricts(val)
      this.areaList = area.districtList
      // this.joinAddress()
    },
    //县区级地址发生改变
    async handleArea(val) {
      this.streetList = []
      this.communityList = []
      this.formData.streetId = ""
      this.formData.communityId = ""
      this.formData.address = ""
      // val = val.replace(/.$/, "");
      let streetList = this.getStreetList(val)
      this.streetList = streetList
      // this.joinAddress()
    },
    //街道地址发生变化
    async streetChange(val) {
      this.formData.communityId = ""
      let communityList = this.getCommityList(val)
      this.communityList = communityList
    },

    //获取地址
    getDistricts(name = "中国", params = null) {
      let self = this
      return new Promise((resolve, reject) => {
        var opts = {
          subdistrict: 1, //返回下一级行政区
          extensions: "all",
          showbiz: false, //最后一级返回街道信息
        }
        let district = new AMap.DistrictSearch(opts)
        let geocoder = new AMap.Geocoder({
          city: "", //城市设为北京，默认：“全国”
          radius: 1000, //范围，默认：500
        })
        try {
          self.myMap.remove(self.marker)
        } catch (err) {
          // console.log(err);
        }

        self.marker = new AMap.Marker()
        district.search(name, (status, result) => {
          if (status == "complete") {
            resolve(result.districtList[0])
          }
        })
      }).catch((err) => {})
    },

    // 地图
    getMap(input) {
      const self = this
      const autoOptions = {
        city: this.formData.areaId,
        citylimit: true,
        input: input,
      }
      // alert(input)
      const auto = new AMap.Autocomplete(autoOptions)
      //构造地点查询类
      AMap.event.addListener(auto, "select", (e) => {
        self.formData.address = e.poi.name
        self.formData.longitude = e.poi.location.lng
        self.formData.latitude = e.poi.location.lat
        self.potintMap()
      })
    },

    //加载地图
    loadmap(index) {
      let self = this
      return new Promise((resolve, reject) => {
        self.myMap = new AMap.Map(index, {
          resizeEnable: true,
          zoom: 18,
        })
        resolve()
      })
    },
    //获取省级
    async getProvince() {
      let province = await this.getDistricts()
      this.provinceList = province.districtList
    },

    getDistrict(name = "中国", params = null) {
      let self = this
      return new Promise((resolve, reject) => {
        var opts = {
          subdistrict: 1, //返回下一级行政区
          extensions: "all",
          showbiz: false, //最后一级返回街道信息
        }
        let district = new AMap.DistrictSearch(opts)
        let geocoder = new AMap.Geocoder({
          city: "", //城市设为北京，默认：“全国”
          radius: 1000, //范围，默认：500
        })
        try {
          self.myMap.remove(self.marker)
        } catch (err) {
          // console.log(err);
        }

        self.marker = new AMap.Marker()
        district.search(name, (status, result) => {
          if (status == "complete") {
            resolve(result.districtList[0])
            if (this.isMap) {
              this.isMap = false
              return
            }
            let bounds = result.districtList[0].boundaries
            self.polygon = null
            if (bounds) {
              try {
                self.myMap.remove(self.polygons)
              } catch (error) {}
              self.polygons = []
              for (let i = 0, l = bounds.length; i < l; i++) {
                self.polygon = new AMap.Polygon({
                  map: self.myMap,
                  strokeWeight: 1,
                  strokeColor: "#0091ea",
                  fillColor: "#80d8ff",
                  fillOpacity: 0.4,
                  path: bounds[i],
                })
                self.polygons.push(self.polygon)
                if (!params) {
                  self.polygon.on("click", function (e) {
                    let lnglat = e.lnglat
                    self.myMap.add(self.marker)
                    self.marker.setPosition(lnglat)
                    geocoder.getAddress(lnglat, function (status, result) {
                      if (status === "complete" && result.regeocode) {
                        var address = result.regeocode.formattedAddress
                        self.formData.address = address
                        self.formData.latitude = lnglat.lng
                        self.formData.longitude = lnglat.lat
                      } else {
                        console.error("根据经纬度查询地址失败")
                      }
                    })
                  })
                  self.myMap.add(self.polygons)
                  self.myMap.setFitView() //地图自适应
                } else {
                  if (params.longitude && params.latitude) {
                    self.myMap.add(self.marker)
                    self.marker.setPosition([params.longitude, params.latitude])
                    self.myMap.setFitView(self.marker)
                    self.myMap.setZoom(11)
                  }
                }
              }
            }
          }
        })
      }).catch((err) => {})
    },

    loopNode(node, arr) {
      if (node.parent == null) {
        return arr
      } else {
        arr.push(node.data.orgId)
        this.loopNode(node.parent, arr)
      }
    },

    //获取组织机构
    getOrg() {
      this.$http
        .request({
          url: "/rbac/admin/org/info/findOrgById",
          method: "POST",
          data: { id: this.$store.state.info.orgId },
        })
        .then((res) => {
          if (res.code == 200) {
            this.normalInfo = res.content
          } else {
            this.$message.error(res.message)
          }
        })
    },
    async changeFirst() {
      let provice = await this.getDistricts()
      this.provinceList = provice.districtList
      if (this.normalInfo.provinceId == 0) {
        this.normalInfo.provinceId = ""
      } else {
        this.normalInfo.provinceId = String(this.normalInfo.provinceId)
        let cityList = await this.getDistricts(this.normalInfo.provinceId)
        this.cityList = cityList.districtList
      }
      if (this.normalInfo.cityId) {
        this.normalInfo.cityId = String(this.normalInfo.cityId)
        let areaList = await this.getDistricts(this.normalInfo.cityId)
        this.areaList = areaList.districtList
      } else {
        this.normalInfo.cityId = ""
      }

      if (this.normalInfo.areaId) {
        this.normalInfo.areaId = String(this.normalInfo.areaId)
        let streetList = await this.getStreetList(this.normalInfo.areaId)
        this.streetList = streetList
      } else {
        this.normalInfo.areaId = ""
      }
      if (this.normalInfo.streetId) {
        this.normalInfo.streetId = String(this.normalInfo.streetId)
        let communityList = await this.getCommityList(this.normalInfo.streetId)
        this.communityList = communityList
      } else {
        this.normalInfo.streetId = ""
      }
      if (this.normalInfo.orgLevel == 1 || this.normalInfo.orgLevel == 0) {
        this.provinceList.forEach((item) => {
          if (item.adcode == this.normalInfo.provinceId) {
            this.formData.latitude = item.center.lat
            this.formData.longitude = item.center.lng
            this.formData.latitude = item.center.lat
            this.formData.longitude = item.center.lng
          }
        })
      } else if (this.normalInfo.orgLevel == 2) {
        this.cityList.forEach((item) => {
          if (item.adcode == this.normalInfo.cityId) {
            this.formData.latitude = item.center.lat
            this.formData.longitude = item.center.lng
            this.formData.latitude = item.center.lat
            this.formData.longitude = item.center.lng
          }
        })
      } else if (this.normalInfo.orgLevel == 3) {
        this.areaList.forEach((item) => {
          if (item.adcode == this.normalInfo.areaId) {
            this.formData.latitude = item.center.lat
            this.formData.longitude = item.center.lng
            this.formData.latitude = item.center.lat
            this.formData.longitude = item.center.lng
          }
        })
      } else if (
        this.normalInfo.orgLevel == 4 ||
        this.normalInfo.orgLevel == 5
      ) {
        this.streetList.forEach((item, index) => {
          if (item.addCode == this.normalInfo.streetId) {
            this.formData.latitude = item.latitude
            this.formData.longitude = item.longitude
            this.formData.latitude = item.latitude
            this.formData.longitude = item.longitude
          }
        })
      }
      // /this.potintMap()

      if (this.normalInfo.communityId) {
        this.normalInfo.communityId = Number(this.normalInfo.communityId)
      } else {
        this.normalInfo.communityId = ""
      }

      this.formData.provinceId = this.normalInfo.provinceId
      this.formData.cityId = this.normalInfo.cityId
      this.formData.areaId = this.normalInfo.areaId
      this.formData.streetId = this.normalInfo.streetId
      this.formData.communityId = this.normalInfo.communityId
      this.loadmap("container")
      setTimeout(() => {
        this.potintMap()
      }, 500)
      this.$forceUpdate()
    },
    // 打点
    potintMap() {
      const self = this
      try {
        self.myMap.remove(self.marker)
      } catch (err) {}
      self.marker = new AMap.Marker({
        icon: "http://webapi.amap.com/theme/v1.3/markers/n/mark_b.png",
        position: [
          Number(self.formData.longitude),
          Number(self.formData.latitude),
        ],
      })
      self.myMap.add(self.marker)
      self.myMap.setFitView()
    },
    //街道地址列表
    getStreetList(val) {
      let self = this
      return new Promise((resolve, reject) => {
        self.$http
          .request({
            url: "/ypt/admin/addressYpe/info/findList",
            method: "POST",
            data: {
              parentId: val,
              pageNo: 1,
              pageSize: -1,
            },
          })
          .then((res) => {
            if (res.code == 200) {
              if (!res.content) {
                resolve([])
                return
              }
              this.streetList = res.content.list
              resolve(res.content.list)
            } else {
              resolve([])
            }
          })
      }).catch((err) => {})
    },
    // 社区地址列表
    getCommityList(val) {
      let self = this
      return new Promise((resolve, reject) => {
        self.$http
          .request({
            url: "/ypt/admin/standardAddress/info/StandardAddressTree",
            method: "POST",
            data: {
              jiedaoId: val,
            },
          })
          .then((res) => {
            if (res.code == 200) {
              if (!res.content) {
                resolve([])
                return
              }
              resolve(res.content)
            } else {
              resolve([])
            }
          })
      }).catch((err) => {})
    },
    //街道地址发生变化
    async streetChange(val) {
      let communityList = await this.getCommityList(val)
      this.communityList = communityList
      // this.joinAddress()
    },
    handleCommunityChange(val) {
      this.$nextTick(() => {
        this.$forceUpdate()
        //this.joinAddress()
      })
    },
    returnVisitFormClose() {
      this.feedback = ""
    },
    //姓名验证
    checkIdName() {
      if (this.formData.name != "") {
        this.$http
          .request({
            url: "/jjyl/admin/zfCustomer/info/getByIdphone",
            method: "POST",
            data: {
              name: this.formData.name,
            },
          })
          .then((res) => {
            if (res.code == 200) {
              if (res.content != null && res.content.name == 1) {
                this.$message.error("姓名已存在！")
                this.formData.name = ""
              }
            }
          })
      }
    },
    // 验证手机号是否已注册
    checkMobile() {
      console.log(this.formData.phone)
      if (this.formData.phone != "") {
        let validatePhone = /^1[3|4|5|6|7|8|9]\d{9}$/
        if (!validatePhone.test(this.formData.phone)) {
          this.$message.error("手机号格式错误")
        } else {
          if (this.formData.phone != "") {
            this.$http
              .request({
                url: "/jjyl/admin/zfCustomer/info/getByIdphone",
                method: "POST",
                data: {
                  phone: this.formData.phone,
                },
              })
              .then((res) => {
                if (res.code == 200) {
                  if (res.content != null && res.content.name == 1) {
                    this.$message.error("手机号已存在！")
                    this.formData.phone = ""
                  }
                }
              })
          }
        }
      }
    },
    // 验证身份证号是否已注册
    checkIdNumber() {
      // if (this.formData.idCard == '340803199606112210') {
      //   // console.log('身份证号已存在！');
      //   this.$message.error('身份证号已存在！')
      //   this.formData.idCard = ''
      // }
      if (this.cardIn == false) {
        if (this.formData.idCard != "") {
          this.$http
            .request({
              url: "/jjyl/admin/zfCustomer/info/getByIdphone",
              method: "POST",
              data: {
                idCard: this.formData.idCard,
              },
            })
            .then((res) => {
              if (res.code == 200) {
                if (res.content != null && res.content.name == 1) {
                  this.$message.error("身份证号已存在！")
                  this.formData.idCard = ""
                }
              }
            })
        }
      }
    },
    // 身份证获取信息
    idCardchange(val) {
      console.log(val)
      // let obj = discriCard(val)
      // console.log(obj)
      //出生年月
      var birthday = ""
      if (val != null && val != "") {
        if (val.length == 15) {
          birthday = "19" + val.substr(6, 6)
        } else if (val.length == 18) {
          birthday = val.substr(6, 8)
        }
        birthday = birthday.replace(/(.{4})(.{2})/, "$1-$2-")
      }
      this.formData.birthday = birthday
      // 性别
      if (val.length == 18) {
        if (val.charAt(16) % 2 == 0) {
          this.formData.gender = "1"
        } else {
          this.formData.gender = "0"
        }
      } else if (val.length == 15) {
        if (val.charAt(14) % 2 == 0) {
          this.formData.gender = "1"
        } else {
          this.formData.gender = "0"
        }
      } else {
        return ""
      }
      // 年龄
      var myDate = new Date()
      var month = myDate.getMonth() + 1
      var day = myDate.getDate()
      var age = myDate.getFullYear() - val.substring(6, 10) - 1
      if (
        val.substring(10, 12) < month ||
        (val.substring(10, 12) == month && val.substring(12, 14) <= day)
      ) {
        age++
      }
      this.formData.age = age
    },

    // 搜索条件
    showSearch() {
      this.searchValue = !this.searchValue
    },

    // 筛选功能按钮
    tableShow() {
      console.log(this.checkList, "this.checkList")
      if (this.checkList.length > 0) {
        if (this.checkList.findIndex((obj) => obj == "序号") == -1) {
          this.no1 = false
        } else {
          this.no1 = true
        }
        if (this.checkList.findIndex((obj) => obj == "姓名") == -1) {
          this.no2 = false
        } else {
          this.no2 = true
        }
        if (this.checkList.findIndex((obj) => obj == "年龄") == -1) {
          this.no3 = false
        } else {
          this.no3 = true
        }
        if (this.checkList.findIndex((obj) => obj == "性别") == -1) {
          this.no4 = false
        } else {
          this.no4 = true
        }
        if (this.checkList.findIndex((obj) => obj == "手机号码") == -1) {
          this.no5 = false
        } else {
          this.no5 = true
        }
        if (this.checkList.findIndex((obj) => obj == "老人类别") == -1) {
          this.no6 = false
        } else {
          this.no6 = true
        }
        if (this.checkList.findIndex((obj) => obj == "用户类型") == -1) {
          this.no7 = false
        } else {
          this.no7 = true
        }
        if (this.checkList.findIndex((obj) => obj == "居住地址") == -1) {
          this.no8 = false
        } else {
          this.no8 = true
        }
        if (this.checkList.findIndex((obj) => obj == "信息回访进度") == -1) {
          this.no9 = false
        } else {
          this.no9 = true
        }
        if (this.checkList.findIndex((obj) => obj == "走访探望进度") == -1) {
          this.no10 = false
        } else {
          this.no10 = true
        }
        if (this.checkList.findIndex((obj) => obj == "操作") == -1) {
          this.no12 = false
        } else {
          this.no12 = true
        }
      }
    },
    // 新增老人
    submitForm() {
      let obj = common.organization(this.arrOrgList, this.normalInfo.orgLevels)
      if (!this.formData.provinceId) {
        this.$message.error("省级地址为必填项，请到资源库完善地址")
        return
      }
      if (!this.formData.cityId) {
        this.$message.error("市级地址为必填项，请到资源库完善地址")
        return
      }
      if (!this.formData.areaId) {
        this.$message.error("区县级地址为必填项，请到资源库完善地址")
        return
      }
      if (!this.formData.streetId) {
        self.$message.error("街道地址为必填项，请到资源库完善地址")
        return
      }
      if (
        this.formData.communityId === "" ||
        this.formData.communityId === null ||
        this.formData.communityId === undefined
      ) {
        this.$message.error("社区为必填项，请选择,如无对应社区，请地址管理配置")
        return
      }
      if (!this.formData.address) {
        this.$message.error(
          "详细信息为必填项，请在地图的边界内点击选择详细信息"
        )
        return
      }
      // if (this.dialogTitle == "新增") {
      // if (this.formData.idCard != "") {
      //     this.$http
      //         .request({
      //             url: "/jjyl/admin/zfCustomer/info/getByIdphone",
      //             method: "POST",
      //             data: {
      //                 idCard: this.formData.idCard,
      //             },
      //         })
      //         .then((res) => {
      //             if (res.code == 200) {
      //                 if (
      //                     res.content != null &&
      //                     res.content.name == 1
      //                 ) {
      //                     this.$message.error("身份证号已存在！")
      //                     this.formData.idCard = ""
      //                     return false
      //                 }
      //             }
      //         })
      // }
      // if (this.formData.phone != "") {
      //     this.$http
      //         .request({
      //             url: "/jjyl/admin/zfCustomer/info/getByIdphone",
      //             method: "POST",
      //             data: {
      //                 phone: this.formData.phone,
      //             },
      //         })
      //         .then((res) => {
      //             if (res.code == 200) {
      //                 if (
      //                     res.content != null &&
      //                     res.content.name == 1
      //                 ) {
      //                     this.$message.error("手机号已存在！")
      //                     this.formData.phone = ""
      //                     return false
      //                 }
      //             }
      //         })
      // }
      //    } // 新增
      this.$refs.formData.validate((valid) => {
        if (this.dialogTitle == "编辑") {
          this.formData.oldId = this.formData.lsId
          this.formData.phone = ""
          this.formData.idCard = ""
        }

        if (valid) {
          let params = {
            ...this.formData,
            economicSource: this.formData.economicSource.toString(),
          }
          params = Object.assign({}, params)
          if (this.dialogTitle == "新增") {
            let ff = false
            for (let i in this.tableDate) {
              if (this.tableDate[i].idCard == this.formData.idCard) {
                this.$message("该老人已添加过")
                ff = true
              }
            }
            if (!ff) {
              request({
                url: "/jjyl/admin/zfCustomer/info/insert",
                method: "POST",
                data: params,
              }).then((res) => {
                console.log(res)
                console.log(this.formData)
                if (res.code == 200) {
                  this.showlist()
                  //增加到资源库里面
                  let oldtrue = false
                }
                this.dialogVisible = false
              })
            }
          } else if (this.dialogTitle == "编辑") {
            request({
              url: "/jjyl/admin/zfCustomer/info/update",
              method: "POST",
              data: params,
            }).then((res) => {
              if (res.code == 200) {
                this.showlist()
              }
              this.dialogVisible = false
            })
          }
        }
      })
    },
    showlist() {
      let params = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
      }
      params = Object.assign({}, params)
      this.$http
        .request({
          url: "/jjyl/admin/zfCustomer/info/findList",
          method: "POST",
          data: params,
        })
        .then((res) => {
          if (res.code == 200) {
            if (res.content != null) {
              this.tableDate = res.content.list
              this.total = res.content.count
            } else {
              this.tableDate = []
            }
          }
        })
    },
    batchDelete() {
      var that = this
      var val = this.selectedData
      if (val.length > 0) {
        this.$confirm("确认永久删除吗?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            val.forEach(function (item, index) {
              request({
                url: "/jjyl/admin/zfCustomer/info/deleteById",
                method: "POST",
                data: { id: item.id },
              })
            })
          })
          .then(() => {
            this.resert()
            this.$message({
              type: "success",
              message: "删除成功!",
            })
          })
      } else {
        this.$confirm("请选择要删除的项。", "提示")
      }
      this.$refs.multipleTable.clearSelection()
    },
    batchClear() {
      var that = this
      var val = this.selectedData
      if (val.length > 0) {
        this.dialogVisible6 = true
      } else {
        this.$confirm("请选择要清除的项。", "提示")
      }
    },
    Clears() {
      this.dialogVisible6 = false
      this.isphone = []
    },
    saveClear() {
      var val = this.selectedData
      this.isphone.forEach((item) => {
        if (item == "清除手机号") {
          if (val.length > 0) {
            val.forEach(function (item, index) {
              request({
                url: "/jjyl/admin/zfCustomer/info/updatePhone",
                method: "POST",
                data: { id: item.id },
              }).then((res) => {
                if (res.code == 200) {
                  this.$message({
                    type: "success",
                    message: "清除成功!",
                  })
                }
              })
            })
          }
        }
        if (item == "清除座机号") {
          if (val.length > 0) {
            val.forEach(function (item, index) {
              request({
                url: "/jjyl/admin/zfCustomer/info/updateFamilyCall",
                method: "POST",
                data: { id: item.id },
              }).then((res) => {
                if (res.code == 200) {
                  this.$message({
                    type: "success",
                    message: "清除成功!",
                  })
                }
              })
            })
          }
        }
      })
      this.dialogVisible6 = false
      this.showlist()
      this.isphone = []
    },
    // 导出
    Export() {
      this.request2({
        url: "/jjyl/admin/zfCustomer/info/zfCustomerInformation",
        method: "POST",
        excel: true,
        data: {
          name: this.username,
          gender: this.gender,
          idCode: this.idCode,
        },
        responseType: "blob",
      }).then((res) => {
        if (res) {
          const blob = new Blob([res], {
            type: "application/vnd.ms-excel",
          })
          const fileName = "老人管理.xls"
          const linkNode = document.createElement("a")
          linkNode.download = fileName //a标签的download属性规定下载文件的名称
          linkNode.style.display = "none"
          linkNode.href = URL.createObjectURL(blob) //生成一个Blob URL
          document.body.appendChild(linkNode)
          linkNode.click() //模拟在按钮上的一次鼠标单击
          URL.revokeObjectURL(linkNode.href) // 释放URL 对象
          document.body.removeChild(linkNode)
          this.$message.success("导出表格成功")
        }
      })
    },

    // 走访进度查看
    look(val, num, tfbool) {
      // return
      this.dialogVisible5 = true
      this.dialogTitle1 = val
      let date = num
      this.check = tfbool
      var infoid = ""
      this.infoid = date.id
      var evaluateTypeId = ""
      this.evaluateTypeId = date.xxlxId
      if (val == "信息回访") {
        this.letChange()
        this.schedule = true
        this.zfxxindex = "信息回访"
      }
      if (val == "走访探望") {
        this.zfggList()
        this.zfxxindex = "走访探望"
        this.schedule = false
      }
    },
    zfggList() {
      let params = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        oldId: this.infoid,
        serviceType: 0,
      }

      request({
        url: "/jjyl/admin/zfpgdContent/info/findbyOld",
        method: "POST",
        data: params,
      }).then((res) => {
        if (res.code == 200) {
          this.tableDate4 = res.content.list
          this.total2 = res.content.count
        } else {
          this.tableDate4 = []
          this.total2 = 0
        }
      })
    },
    letChange() {
      let params = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        oldId: this.infoid,
        serviceType: 1,
      }
      request({
        url: "/jjyl/admin/zfpgdContent/info/findbyOld",
        method: "POST",
        data: params,
      }).then((res) => {
        if (res.code == 200) {
          this.tableDate1 = res.content.list
          this.total3 = res.content.count
        } else {
          this.tableDate1 = []
          this.total3 = 0
        }
      })
    },
    // 走访进度点击切换
    changeProgress(index) {
      this.stepIndex1 = index
      this.feedback = ""
    },

    // 探望查看
    async look2(title, index, date) {
      console.log(title)
      let _this = this

      this.title1 = title
      if (index == "走访进度") {
        let self = this
        self.dialogVisible3 = true
        this.feedback = ""

        self.visitShow = true
        // setTimeout(async () => {
        await self.$nextTick(() => self.loadmap("container1"))
        // }, 3000)
        // 走访探望
        if (this.zfxxindex == "走访探望") {
          this.stepTitle = "走访探望"
          self.twnrShow = true
          this.progressCheck(date)
          return
        }
        // 信息回访
        if (this.zfxxindex == "信息回访") {
          this.stepTitle = "信息回访"
          self.twnrShow = false
          if (date != null) {
            this.formData = date
            this.huodeId = date.id

            // let temp = JSON.stringify(this.formData)
            // let jsonTemp = JSON.parse(temp)
            let jsonTemp = { ...this.formData }
            this.formData.elderlyBelongCategory = jsonTemp.elderlyBelongCategory
            this.formData.streetId = String(jsonTemp.streetId)
            this.formData.communityId = Number(jsonTemp.communityId)
            if (!jsonTemp.provinceId) return
            let city = await self.getDistrict(jsonTemp.provinceId)
            self.cityList = city.districtList
            if (!jsonTemp.cityId) return
            let area = await this.getDistrict(jsonTemp.cityId)
            self.areaList = area.districtList
            if (!jsonTemp.areaId) return
            let streetList = await self.getStreetList(jsonTemp.areaId)
            self.streetList = streetList
            if (!jsonTemp.streetId) return
            let communityList = await self.getCommityList(jsonTemp.streetId)
            self.communityList = communityList
            this.$forceUpdate()
          }
          if (date.zfpgdQuestionList.length > 0) {
            this.currentZfEvaluateContentLis = date.zfpgdQuestionList
            return
          }
          this.returnVisitForm.feedback = date.feedback
          _this.$http
            .request({
              url: "/jjyl/admin/zfevaluateType/info/getById",
              method: "POST",
              data: {
                id: 26,
                pageSize: 100,
                pageNo: 1,
              },
            })
            .then((res) => {
              if (res.code == 200) {
                if (res.content == null || res.content == "null") {
                  this.currentZfEvaluateContentLis = []
                  return
                }
                this.currentZfEvaluateContentLis =
                  res.content.zfEvaluateContentList
              }
            })

          return
        }
      }
      if (index == "探望记录") {
        let self = this
        self.dialogVisible3 = true
        self.visitShow = false
        self.stepIndex1 = 2
        if (date.returnType == "信息回访") {
          self.twnrShow = false
        }
        if (date.returnType == "上门回访") {
          self.twnrShow = true
        }
      }
    },

    // 进度查看
    progressCheck(date) {
      let params = {
        id: date.id,
      }
      let self = this
      params = Object.assign({}, params)
      request({
        url: "/jjyl/admin/zfpgdContent/info/getContentById",
        method: "POST",
        data: params,
      }).then(async (res) => {
        self.huodeId = res.content.id
        if (res.code == 200) {
          self.formData = res.content

          // delete ;
          self.formData.questionName = res.content.questionName
            ? res.content.questionName
            : []
          self.formData.elderlyBelongCategory =
            res.content.elderlyBelongCategory
          self.returnVisitForm1 = res.content.zfpgdQuestionList
          let jsonTemp = { ...res.content }
          self.formData.streetId = String(jsonTemp.streetId)
          self.formData.communityId = Number(jsonTemp.communityId)
          if (!jsonTemp.provinceId) return
          let city = await self.getDistrict(jsonTemp.provinceId)
          self.cityList = city.districtList
          if (!jsonTemp.cityId) return
          let area = await this.getDistrict(jsonTemp.cityId)
          self.areaList = area.districtList
          if (!jsonTemp.areaId) return
          let streetList = await self.getStreetList(jsonTemp.areaId)
          self.streetList = streetList
          if (!jsonTemp.streetId) return
          let communityList = await self.getCommityList(jsonTemp.streetId)
          self.communityList = communityList
          this.$forceUpdate()

          this.feedback = res.content.feedback
          this.addForm1 = res.content
          this.addForm1.birthday = res.content.birthday
          this.inmageList = res.content.visitPhoto.split("_")
          this.addForm1.esElderlyDemand = res.content.esElderlyDemand.split(",")

          try {
            if (res.content.medicalHistory != null) {
              this.addForm1.medicalHistory =
                res.content.medicalHistory.split(",")
            }
            if (res.content.elderlyCategory != null) {
              this.addForm1.elderlyCategory =
                res.content.elderlyCategory.split(",")
            }
          } catch (err) {}
        }
      })
    },

    // 指派
    look3(title, row) {
      this.dialogTitle4 = title
      this.dialogVisible4 = true
      this.assign = {
        person: row.person,
        phone: row.phone,
        reflectChannel: row.reflectChannel,
        //  feedbackType: row.feedbackType,
        feedbackTime: row.feedbackTime,
        isFeedbackName: "1",
        photo: row.photo ? row.photo.split(",") : [],
        visitPhoto: row.visitPhoto ? row.visitPhoto.split(",") : [],
        isRecord: "1",
        address: row.address,
        personId: "",
        departmentId: "",
        feedback: row.feedback,
        name: row.name,
        personPhone: "",
        id: row.id,
        updateDate: row.updateDate,
      }
      // this.assign = row
      if (this.assign.reflectChannel == 0) {
        this.assign.feedbackType = "APP"
      } else if (this.assign.reflectChannel == 1) {
        this.assign.feedbackType = "APP"
      } else {
        this.assign.feedbackType = ""
      }
      this.assign.visitTime = row.visitTime
      if (title == "查看") {
        this.$http
          .request({
            url: "jjyl/admin/zfpgdContent/info/getContentById",
            method: "POST",
            data: {
              id: row.id,
            },
          })
          .then((res) => {
            if (res.content != null) {
              this.assign = res.content
              this.selectDepart(this.assign.serverStationId)

              if (this.assign.photo != null) {
                this.assign.photo = this.assign.photo.split(",")
              }
            }
          })
      }
    },
    // 弹框关闭
    handleClose() {
      this.dialogVisible = false
    },
    // 弹框关闭C
    handleAddFormClose() {
      this.$refs.formData.resetFields()
      this.tableDate3 = []
    },

    // 查询
    query() {
      let params = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        ...this.form,
      }
      params = Object.assign({}, params)
      request({
        url: "/jjyl/admin/zfCustomer/info/findList",
        method: "POST",
        data: params,
      }).then((res) => {
        if (res.code == 200) {
          if (res.content != null) {
            this.tableDate = res.content.list
            this.total = res.content.count
          } else {
            this.tableDate = []
          }
        }
      })
    },

    async showdelete(id) {
      const confirmResult = await this.$confirm(
        "此操作将永久删除该用户, 是否继续?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).catch((err) => err)
      if (confirmResult !== "confirm") {
        return this.$message.info("已经取消删除")
      }
      let res = await this.$http.post(
        "/jjyl/admin/zfCustomer/info/deleteById",
        { id: id }
      )
      if (res.code !== 200) {
        this.$message.error("删除数据失败")
      }
      this.$message.success("删除数据成功")
      this.showlist()
    },
    // 保存
    save() {
      let self = this
      if (this.dialogVisible4 == true) {
        this.$refs.assign.validate((valid) => {
          if (valid) {
            this.assign.feedbackstate = 1
            let params = this.assign
            params = Object.assign({}, params)
            params.photo = this.assign.photo.toString()
            params.visitPhoto = this.assign.visitPhoto.toString()
            request({
              url: "/jjyl/admin/zfpgdContent/info/assign",
              method: "POST",
              data: params,
            }).then((res) => {
              // console.log(res);
              if (res.code == 200) {
                this.dialogVisible4 = false
                var id = this.tableId
                this.getFeedBack(id)
              } else {
                this.$message.error(res.message)
              }
            })
          }
        })
      } else {
        this.dialogVisible = false
      }
    },

    // 保存
    save1() {
      this.dialogVisible2 = false
    },

    // 保存
    save2() {
      // this.$refs.addForm.validate((valid) => {
      //   if (valid) {
      let params = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        zfpgdQuestionList: this.currentZfEvaluateContentLis,
        feedback: this.returnVisitForm.feedback,
        id: this.huodeId,
        states: "1",
      }
      params = Object.assign({}, params)
      request({
        url: "/jjyl/admin/zfpgdContent/info/update",
        method: "POST",
        data: params,
      }).then((res) => {
        if (res.code == 200) {
          this.dialogVisible3 = false
          var id = this.infoid
          this.getFeedBack(id)
          this.letChange()
        }
      })
      // }
      //   });
    },

    // 选择人员
    selectDepart(val) {
      let params = {
        departmentId: val,
        webfrom: "2",
      }
      params = Object.assign({}, params)
      request({
        url: "/jjyl/admin/person/info/findPersonByDept",
        method: "POST",
        data: params,
      }).then((res) => {
        this.personIdOptions = res.content
        if (this.assign.serverPersonId) {
          this.selectPersont(this.assign.serverPersonId)
        }
      })
    },
    selectPersont(val) {
      this.personIdOptions.forEach((item) => {
        if (item.id == val) {
          this.assign.serverPersonPhone = item.personPhone
        }
      })
    },
    // 获取数据
    getServiceStationList() {
      let params = {
        pageNo: 1,
        pageSize: 1000,
      }
      this.$http
        .request({
          url: "/ypt/admin/serviceStation/info/findList",
          method: "POST",
          data: params,
        })
        .then((res) => {
          if (res.code == 200) {
            if (res.content == null || res.content == "null") {
              this.optionsType = []
              return
            }
            this.optionsType = res.content.list
          }
        })
    },
    // 弹窗
    //处理table表格表单
    async handleClick(title, index, row = {}) {
      let self = this
      this.tableId = row.id
      this.imageUrl = ""
      self.dialogTitle = title
      self.dialogVisible = true
      self.stepIndex = index
      self.currentRow = row
      self.visitShow1 = false
      // self.refs.formData
      // self.$refs.formData.resetFields()
      // setTimeout(async () => {
      //     await self.$nextTick(() => self.loadmap("container"))
      // }, 30)

      switch (self.stepIndex) {
        case 0:
          self.formData.id = ""
          self.formData.age = ""
          self.formData.birthday = ""
          self.formData.lifeArea = ""
          self.formData.liveCondition = ""
          self.formData.economicSource = []
          self.formData.serviceStation = null
          self.formData.provinceId = ""
          self.formData.cityId = ""
          self.formData.areaId = ""
          self.formData.streetId = ""
          self.formData.communityId = ""
          self.formData.address = ""
          self.formData.name = ""
          self.formData.phone = ""
          self.formData.idCard = ""
          self.formData.gender = ""
          self.formData.nation = ""
          self.formData.livingArea = ""
          self.formData.elderlyBelongCategory = ""
          self.formData.minzhengIndex = ""
          self.formData.orgName = ""
          self.imageUrl = ""
          self.formData.photo = ""
          self.$nextTick(() => self.loadmap("container"))
          break
        case 1:
          // 查看
          this.seeList(row)
          break
        case 2:
          this.footShow = true
          break
        case 3:
          // 探望记录
          this.visitView(row)
          break
        case 4:
          this.getFeedBack(row.id)

          break
      }
    },
    // 获取反馈列表
    getFeedBack() {
      this.$http
        .request({
          url: "/jjyl/admin/zfpgdContent/info/findListbyOld",
          method: "POST",
          data: {
            pageNo: 1,
            pageSize: 10,
            oldId: this.tableId,
            feedback: "1",
            states: "1",
          },
        })
        .then((res) => {
          if (res.code == 200) {
            if (res.content != null) {
              this.tableDate3 = res.content.list
              this.total1 = res.content.count
            }
          }
        })
      // 反馈问题查看
      this.visitShow = true
    },
    // 探望记录查看
    visitView(date) {
      let params = {
        pageSiz: this.pageSize,
        pageNo: this.pageNo,
        oldId: date.id,
        states: "1",
        qujiId: JSON.parse(localStorage.getItem("czUserInfo")).qujiId,
        shengjiId: JSON.parse(localStorage.getItem("czUserInfo")).shengjiId,
        shijiId: JSON.parse(localStorage.getItem("czUserInfo")).shijiId,
        stationId: JSON.parse(localStorage.getItem("czUserInfo")).stationId,
        shequjiId: JSON.parse(localStorage.getItem("czUserInfo")).shequjiId,
      }
      params = Object.assign({}, params)
      request({
        url: "/jjyl/admin/zfpgdContent/info/findListbyOld",
        method: "POST",
        data: params,
      }).then((res) => {
        if (res.code == 200) {
          this.tableDate2 = res.content.list
          this.total = res.content.length
        } else {
          this.tableDate2 = []
        }
      })
    },

    // 操作查看
    seeList(date) {
      let self = this
      let params = {
        id: date.id,
      }
      //  params = Object.assign({}, params)
      request({
        url: "/jjyl/admin/zfCustomer/info/getById",
        method: "POST",
        data: params,
      }).then(async (res) => {
        if (res.code == 200) {
          this.formData = res.content
          this.formData.lsId = res.content.oldId
          this.formData.oldId = res.content.customerName
          self.formData.serviceStation = parseInt(res.content.serviceStation)
          if (self.formData.economicSource) {
            self.formData.economicSource =
              self.formData.economicSource.split(",")
          }

          //let temp = JSON.stringify(this.formData)
          let jsonTemp = { ...res.content }
          self.formData.elderlyBelongCategory = jsonTemp.elderlyBelongCategory

          self.formData.streetId = String(jsonTemp.streetId)
          self.formData.communityId = Number(jsonTemp.communityId)
          if (!jsonTemp.provinceId) return
          let city = await self.getDistricts(jsonTemp.provinceId)
          self.cityList = city.districtList
          if (!jsonTemp.cityId) return
          let area = await this.getDistricts(jsonTemp.cityId)
          self.areaList = area.districtList
          if (!jsonTemp.areaId) return
          let streetList = await self.getStreetList(jsonTemp.areaId)
          self.streetList = streetList
          if (!jsonTemp.streetId) return
          let communityList = await self.getCommityList(jsonTemp.streetId)
          self.communityList = communityList
          self.formData.latitude = jsonTemp.latitude
          self.formData.longitude = jsonTemp.longitude
          setTimeout(async () => {
            await self.$nextTick(() => {
              self.loadmap("container")
              self.potintMap()
            })
          }, 30)
          this.$forceUpdate()
        }
      })
    },
    // end
    gettypeList() {
      let query = {
        pageNum: 1,
        pageSize: 999,
        dictType: "customer.type",
      }
      this.$http
        .request({
          url: "/rbac/system/dict/data/list",
          method: "get",
          params: query,
        })
        .then((res) => {
          if (res.code == 200) {
            if (res.rows != null) {
              this.oldtypeLits = res.rows
              this.oldtypeLits.forEach((item) => {
                item.dictCode = String(item.dictCode)
              })
            }
          }
        })
    },
    // 图片上传 start
    handleAvatarSuccess(res, file) {
      this.imageUrl = res.content
      //  this.imageUrl = "http://36.33.216.70:8066/qianmi-wisdom-veterans-web-api/photoUpload/2021/03/18/6e91e5fa-6c99-4dbe-8278-c2cd21d938a714a1e683bc101fe561d4aaa9e177d999.jpg";
      this.formData.photo = res.content
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg" || file.type === "image/png"
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式!")
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!")
      }
      return isJPG && isLt2M
    },

    // 行点击选中
    openDetails(row, event, column, cell) {
      this.$refs.multipleTable.toggleRowSelection(row)
      this.row = row
      this.column = column
    },
    handleSelectionChange(rows) {
      this.multipleSelection = rows
    },

    handleSelectionChange(data) {
      this.selectedData = data
    },
    // 打印
    dy() {
      this.$print(this.$refs.print)
    },
    // 重置
    resert() {
      this.form.customerName = ""
      this.form.lifeArea = ""
      this.form.minzhengIndex = ""
      this.showlist()
    },

    // 表单刷新
    resertTable() {
      this.showlist()
      this.checkList = [
        "序号",
        "姓名",
        "年龄",
        "性别",
        "手机号码",
        "老人类别",
        "用户类型",
        "居住地址",
        "信息回访进度",
        "走访探望进度",
        "操作",
      ]
      this.tableShow()
    },

    //每页请求数据
    handleSizeChange(val) {
      this.pageSize = val
      this.showlist()
      this.$message({
        message: `每页请求${val}条数据成功`,
        type: "success",
      })
    },
    //请求第几数据
    handleCurrentChange(val) {
      this.pageNo = val
      this.showlist()
      this.$message({
        message: `请求第${val}页数据成功`,
        type: "success",
      })
    },
    //走访探望每页请求数据
    handleSizeChange4(val) {
      this.pageSize = val
      this.zfggList()
      this.$message({
        message: `每页请求${val}条数据成功`,
        type: "success",
      })
    },
    //请求第几数据
    handleCurrentChange4(val) {
      this.pageNo = val
      this.zfggList()
      this.$message({
        message: `请求第${val}页数据成功`,
        type: "success",
      })
    },
    //信息回访每页请求数据
    handleSizeChange1(val) {
      this.pageSize = val
      this.letChange()
      this.$message({
        message: `每页请求${val}条数据成功`,
        type: "success",
      })
    },
    //请求第几数据
    handleCurrentChange1(val) {
      this.pageNo = val
      this.letChange()
      this.$message({
        message: `请求第${val}页数据成功`,
        type: "success",
      })
    },
    //反馈问题每页请求数据
    handleSizeChange3(val) {
      this.pageSize = val
      this.getFeedBack()
      this.$message({
        message: `每页请求${val}条数据成功`,
        type: "success",
      })
    },
    //请求第几数据
    handleCurrentChange3(val) {
      this.pageNo = val
      this.getFeedBack()
      this.$message({
        message: `请求第${val}页数据成功`,
        type: "success",
      })
    },

    // 刷新页面
    Resert() {
      this.reload()
    },
    // 部门列表
    async departmentlist() {
      let params = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        webfrom: "2",
      }
      params = Object.assign({}, params)
      await request({
        url: "/jjyl/admin/department/info/findList",
        method: "POST",
        data: params,
      }).then((res) => {
        if (res.content != null) {
          this.departmentDate = res.content.list
          this.total = res.content.count
        } else {
          this.departmentDate = []
          this.total = 0
        }
      })
    },
  },
}
</script>
<style lang="less" scoped>
.rkld {
  display: flex;
  flex-direction: row;
  height: 100vh;
  overflow: hidden;
}

.rkldLeft {
  width: 234px;
  height: 100%;
  background: #37404f;
}

.rkldLeftLogo {
  background-color: rgb(55, 64, 79);
  height: 68px;
  width: 100%;
  display: flex;
  align-items: center;
  color: #ffffff;
}

.rkldLeftLogoImage {
  width: 39px;
  margin-left: 20px;
  margin-right: 10px;
}

.rkldRight {
  flex: 1;
  height: 100%;
  width: calc(100% - 266px);
  background-color: #ffffff;
}

.rkldRightHead {
  border-bottom: 1px solid #f5f5f5;
  width: 100%;
  background-color: #ececec;
  height: 69px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.mlIcon {
  height: 35px;
  width: 35px;
  font-size: 14px;
  margin-left: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border-radius: 3px;
}

.mlIcon:hover {
  background: rgba(0, 0, 0, 0.1);
}

::-webkit-scrollbar {
  display: none !important;
}

.rkldRightHeadRight {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-right: 15px;
}

.demo-form-inline {
  padding: 0 5%;
}

.btnform {
  text-align: center;
}

.bodymsg {
  width: 140px;
  height: 40px;
  background-color: #ffb404;
  color: #fff;
  text-align: center;
  line-height: 40px;
  border-radius: 2px;
  margin-top: 20px;
  cursor: pointer;
}

.switchpage {
  display: inline-block;
  margin-bottom: 10px;
}

.activesiwtch {
  background-color: #d6d7d8;
}

.rkldRightHeadRightLeft {
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 12px;
}

.rkldRightHeadRightLeft img {
  margin-right: 5px;
}

.rkldRightContent {
  height: calc(100% - 70px);
  overflow-y: auto;
  margin: 20px;
}

.searchTj {
  display: flex;
  flex-direction: column;
  position: relative;
  background: #f1f2f6;
  box-shadow: 0 0 6px rgba(151, 151, 151, 0.16);
  overflow: hidden;
  border-radius: 4px;
  margin: 5px;
}

.searchTjHead {
  background: #fff;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  color: rgb(0, 0, 0);
  border-color: rgb(217, 217, 217);
  padding: 6px 15px;
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
}

.searchTjContent {
  padding: 15px 20px 0px 5px;
  border: 1px solid rgb(217, 217, 217);
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

.searchTjContentDiv {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-left: 40px;
  margin-bottom: 10px;
  border-radius: 4px;
}

.searchTjContentDivSpan {
  min-width: 58px;
  margin-right: 20px;
  font-size: 14px;
}

.searchTjContentDivInput {
  width: 20%;
  min-width: 196px;
}

/deep/ .arrowDown {
  width: 28px;
  height: 28px;
  background: #edf2f0;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  left: 50%;
  bottom: -14px;
  transform: translate(-50%, 0px) 2s;
  border-radius: 50%;
  z-index: 2;
  cursor: pointer;
  // transition: 2s;
}

/deep/ .el-tabs__content {
  padding-bottom: 20px;
}

.searchButtonDiv {
  height: 54px;
  display: flex;
  margin-top: 14px;
  align-items: center;
  justify-content: space-between;
}

.searchButtonDivLeft {
  display: flex;
}
.phonecss /deep/.el-input__inner {
  height: 30px;
  line-height: 30px;
}
/deep/ .el-button {
  border-radius: 4px;
  padding: 0px 8px !important;
  border: none;
  height: 30px;
}

.el-button-group /deep/ .el-button--warning:last-child {
  border-left-color: rgba(255, 255, 255, 0.5);
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}

/deep/ .el-pagination {
  margin-top: 10px;
}

/* 用来设置当前页面element全局table 选中某行时的背景色*/
/deep/ .el-table__body tr.current-row > td {
  background-color: #fafad2 !important;
  color: #000;
}

/deep/ .el-table tbody tr:hover > td {
  background-color: #fafad2 !important;
}

/deep/ .span_icon {
  margin: 0 10px;
}

.mapleft {
  margin-left: 10px;
  width: 200px;
  height: 400px;
  overflow-y: auto;
  border: 1px solid #dcdfe6;
  border-radius: 5px;

  p {
    line-height: 42px;
    text-align: center;
  }
}

// 弹框样式
/deep/ .el-dialog {
  .el-dialog__header {
    border-bottom: 1px solid #e6e6e6;
  }

  .el-dialog__footer {
    background: #e6e6e6;
  }

  // 弹框步骤条样式
  .el-step__icon.is-text {
    border-radius: 5px;
  }

  .is-finish .el-step__icon {
    background: #409eff;
  }

  .el-step__icon {
    width: auto;
    padding: 15px 20px;
    color: #ffffff;
    cursor: pointer;
    border: none;
    background: #c0c4cc;
  }

  .el-step {
    height: 40px;
    margin-bottom: 24px;
  }

  .el-step.is-horizontal .el-step__line {
    top: 16px;
  }

  // 上传图片
  /deep/ .upImg {
    text-align: center;
    width: 100%;

    .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      width: 178px;
      text-align: center;
      overflow: hidden;
    }

    .el-form-item__content {
      margin-left: 0px !important;
    }

    .avatar-uploader .el-upload:hover {
      border-color: #409eff;
    }

    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 178px;
      height: 178px;
      line-height: 178px;
      text-align: center;
    }

    .avatar {
      width: 178px;
      height: 178px;

      img {
        width: 178px;
        height: 178px;
        margin-right: 13px;
      }
    }
  }

  .avatar {
    // width: 178px;
    // height: 178px;
    img {
      width: 178px;
      height: 178px;
    }
  }

  // 回访内容
  .return_visit_form {
    .header {
      display: flex;
      justify-content: space-between;
      padding: 24px 0 36px;
    }
  }
}

/deep/ .map_left {
  width: 100%;
  height: 400px;
  overflow-y: auto;
  border: 1px solid #dcdfe6;
  border-radius: 5px;

  p {
    line-height: 42px;
    text-align: center;
  }
}

/deep/ .photoFrom {
  .el-form-item__content {
    margin-left: 0px !important;
  }
}

.addressFrom {
  display: flex;
  margin-left: -50px;
  margin-bottom: 20px;

  .addressTitle {
    text-align: right;
    vertical-align: middle;
    width: 140px;
    font-size: 14px;
    color: #606266;
    line-height: 40px;
    padding: 0 12px 0 0;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;

    span {
      color: #f56c6c;
      margin-right: 4px;
    }
  }

  .addressContent {
    flex: 1;

    .addressBox {
      display: flex;

      .addressItem {
        flex: 1;

        /deep/ .el-form-item__content {
          margin-left: 0px !important;
        }

        /deep/ .el-select {
          width: 100% !important;
        }
      }
    }

    /deep/ .el-form-item__content {
      margin-left: 0px !important;
    }
  }
}
</style>
